import { Coordinate } from "ol/coordinate";

const SYMBOL_DATA: { [key: number]: Coordinate[][] } = {
    1: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.75], [0.48, -0.58], [0.74, -0.14], [0.66, 0.37], [0.25, 0.71], [-0.26, 0.71], [-0.64, 0.37], [-0.74, -0.13], [-0.48, -0.58], [0, -0.75]]
    ],
    2: [
        [[0.4, 0.6], [0, 0.75], [-0.4, 0.6]],
        [[-0.05, 0], [0.05, 0]],
        [[-0.6, 0.4], [-0.75, 0], [-0.59, -0.4]],
        [[0.59, -0.4], [0.75, 0], [0.6, 0.4]],
        [[-0.39, -0.61], [0, -0.75], [0.39, -0.61]]
    ],
    3: [
        [[-0.5, 0.5], [0.53, -0.52], [0.25, -0.15], [0.65, -0.15], [0.6, 0.15], [0.25, 0.15], [0.5, 0.5], [-0.52, -0.5], [-0.25, -0.15], [-0.65, -0.15], [-0.6, 0.15], [-0.25, 0.15]],
        [[0, -0.75], [0.49, -0.58], [0.74, -0.14], [0.65, 0.37], [0.26, 0.7], [-0.25, 0.71], [-0.65, 0.38], [-0.74, -0.13], [-0.48, -0.58], [-0.01, -0.75]]
    ],
    4: [
        [[-0.51, -0.53], [0.5, 0.5]],
        [[-0.5, 0.5], [0.51, -0.52]],
        [[0, -0.75], [0.48, -0.58], [0.74, -0.13], [0.65, 0.38], [0.26, 0.71], [-0.25, 0.71], [-0.64, 0.39], [-0.74, -0.13], [-0.49, -0.57], [0.01, -0.75]]
    ],
    5: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [0.4, -0.31], [0.49, 0.11], [0.22, 0.45], [-0.21, 0.45], [-0.48, 0.12], [-0.39, -0.31], [0, -0.5]]
    ],
    6: [
        [[0.52, -0.52], [-0.49, 0.49]],
        [[-0.51, -0.53], [0.5, 0.49]],
        [[0.01, -2.24], [0.01, -0.97], [0.01, -0.75], [0.5, -0.57], [0.74, -0.13], [0.65, 0.39], [0.27, 0.69], [-0.24, 0.7], [-0.65, 0.37], [-0.73, -0.14], [-0.49, -0.57], [0.01, -0.75]],
        [[-0.3, -1.8], [0.02, -2.25], [0.3, -1.8]]
    ],
    7: [
        [[4.47, -0.3], [4.83, -0.3], [5, 0], [4.82, 0.3], [4.48, 0.31], [4.3, 0], [4.47, -0.3], [4.9, 0], [4.3, 0]],
        [[0.1, -0.15], [1.37, -0.15], [2.64, -0.15], [2.9, -0.15], [2.9, 0.16], [1.63, 0.16], [0.36, 0.16], [0.11, 0.16], [0.11, -0.15]],
        [[0, 0], [0, -0.34], [1.27, -0.34], [2.54, -0.34], [3, -0.35], [3, 0.35], [1.73, 0.35], [0.46, 0.35], [0, 0.35], [0, 0]],
        [[-4.9, -0.15], [-3.63, -0.15], [-2.36, -0.15], [-2.1, -0.15], [-2.09, 0.15], [-3.36, 0.15], [-4.63, 0.15], [-4.9, 0.15], [-4.9, 0], [-4.9, -0.15]],
        [[-5, 0], [-5, -0.35], [-3.73, -0.35], [-2.46, -0.35], [-2, -0.35], [-2, 0.35], [-3.27, 0.35], [-4.54, 0.35], [-4.99, 0.35], [-5, 0]]
    ],
    8: [
        [[1.65, -0.15], [1.65, -0.3], [1.65, -0.35], [2.92, -0.35], [4.19, -0.35], [4.65, -0.35], [4.65, 0.35], [3.38, 0.35], [2.11, 0.35], [1.65, 0.35], [1.65, -0.15], [2.92, -0.15], [4.19, -0.15], [4.5, -0.15], [4.5, 0], [4.5, 0.15], [3.23, 0.15], [1.96, 0.15], [1.65, 0.15]],
        [[-0.35, 0], [-0.17, -0.3], [0.17, -0.3], [0.35, 0], [0.18, 0.3], [-0.17, 0.3], [-0.35, 0], [0.35, 0]],
        [[-4.65, -0.15], [-4.65, -0.3], [-4.65, -0.35], [-3.38, -0.35], [-2.11, -0.35], [-1.65, -0.35], [-1.65, 0.35], [-2.92, 0.35], [-4.19, 0.35], [-4.65, 0.35], [-4.65, -0.15], [-3.38, -0.15], [-2.11, -0.15], [-1.8, -0.15], [-1.8, 0], [-1.8, 0.15], [-3.07, 0.15], [-4.34, 0.15], [-4.65, 0.15]]
    ],
    9: [
        [[2.15, 0], [2.32, -0.3], [2.67, -0.3], [2.85, 0], [2.67, 0.3], [2.33, 0.3], [2.15, 0], [2.85, 0]],
        [[-0.35, 0], [-0.17, -0.3], [0.18, -0.3], [0.35, 0], [0.18, 0.3], [-0.17, 0.3], [-0.35, 0], [0.35, 0]],
        [[-2.85, 0], [-2.68, -0.3], [-2.33, -0.3], [-2.15, 0], [-2.33, 0.3], [-2.68, 0.3], [-2.85, 0], [-2.15, 0]]
    ],
    10: [
        [[0.95, 0], [1.12, -0.3], [1.48, -0.3], [1.65, 0], [1.48, 0.3], [1.12, 0.3], [0.95, 0], [1.65, 0]],
        [[-1.55, 0], [-1.38, -0.3], [-1.03, -0.3], [-0.85, 0], [-1.03, 0.3], [-1.37, 0.3], [-1.55, 0], [-0.85, 0]]
    ],
    11: [
        [[4.3, -0.7], [5.7, 0.7]],
        [[5.7, -0.7], [4.3, 0.7]],
        [[5, 0], [5, 1.5]],
        [[-5, 0], [-5, 1.5]],
        [[-4.3, -0.7], [-5.7, 0.7]],
        [[-5.7, -0.7], [-4.3, 0.7]]
    ],
    12: [
        [[-5.35, 0], [-5.17, -0.31], [-4.82, -0.31], [-4.65, 0], [-4.82, 0.3], [-5.17, 0.3], [-5.35, 0], [-4.65, 0]],
        [[4.65, 0], [4.83, -0.31], [5.18, -0.31], [5.35, 0], [5.18, 0.3], [4.83, 0.3], [4.65, 0], [5.35, 0]]
    ],
    13: [
        [[0, -0.7], [0, 0.7]]
    ],
    14: [
        [[0, 0.7]]
    ],
    15: [
        [[0, -0.7]]
    ],
    16: [
        [[-0.7, 0.7], [0, 0], [0.7, 0.7]]
    ],
    17: [
        [[-0.7, -0.7], [0, 0], [0.7, -0.7]]
    ],
    18: [
        [[0.5, 0], [0.5, -0.7]],
        [[-0.5, -0.7], [-0.5, 0]]
    ],
    19: [
        [[0.5, 0.7], [0.5, 0]],
        [[-0.5, 0], [-0.5, 0.7]]
    ],
    20: [
        [[-0.7, 0], [-0.69, -0.12], [-0.45, -0.54], [0, -0.7], [0.45, -0.54], [0.69, -0.13], [0.7, 0]]
    ],
    21: [
        [[-0.7, 0], [-0.6, 0.35], [-0.25, 0.66], [0.24, 0.65], [0.61, 0.35], [0.7, 0]]
    ],
    22: [
        [[-0.05, 0.75], [0.25, 0.65], [0.37, 0.34], [0.23, 0.07], [-0.25, -0.1], [-0.37, -0.38], [-0.23, -0.67], [0.05, -0.75]]
    ],
    23: [
        [[0.05, -0.75], [-0.26, -0.64], [-0.37, -0.34], [-0.23, -0.09], [0.27, 0.11], [0.37, 0.41], [0.21, 0.68], [-0.05, 0.75]]
    ],
    24: [
        [[0.6, -2], [1.1, -2], [1.45, -1.85], [1.6, -1.5], [1.6, -0.75], [1.6, -0.6], [1.45, -0.15], [1.1, 0], [0.6, 0], [0.6, -2]],
        [[0.45, -1.7], [0.1, -2], [-0.35, -1.85], [-0.5, -1.4], [-0.25, -1.1], [0.25, -0.95], [0.5, -0.5], [0.2, -0.05], [-0.25, -0.05], [-0.5, -0.4]],
        [[-0.75, -1.7], [-1.15, -2], [-1.55, -1.85], [-1.7, -1.4], [-1.7, -0.65], [-1.7, -0.6], [-1.5, -0.1], [-1.1, 0], [-0.7, -0.4]],
        [[-1.4, -2.3], [-1.2, -2.1], [-1, -2.3]]
    ],
    25: [
        [[-0.7, 0], [-0.7, -1.5], [-0.7, -2], [0, -1], [0.7, -2], [0.7, -0.5], [0.7, 0]]
    ],
    26: [
        [[-0.4, -2], [0.1, -2], [0.45, -1.85], [0.6, -1.45], [0.6, -0.7], [0.6, -0.5], [0.4, -0.1], [0.1, 0], [-0.4, 0], [-0.4, -2]]
    ],
    27: [
        [[1.2, -2], [0.45, -2], [0.2, -2]],
        [[0.7, 0], [0.7, -2]],
        [[-0.7, -1], [-0.325, -0.25], [-0.2, 0]],
        [[-1.2, 0], [-1.2, -2], [-0.7, -2], [-0.3, -1.8], [-0.3, -1.25], [-0.7, -1], [-1.2, -1]]
    ],
    28: [
        [[0, -3], [0, 0], [1, 0]]
    ],
    29: [
        [[0.75, -2.5], [-0.35, -2.3], [-0.65, -2.1], [-0.65, -1.7], [0.65, -0.8], [0.65, -0.4], [0.3, -0.2], [-0.75, 0]]
    ],
    30: [
        [[1, 0], [0, 0], [-0.25, -0.05], [-0.65, -0.37], [-0.73, -0.88], [-0.48, -1.32], [0, -1.5], [0.5, -1.32], [0.75, -0.88], [0.65, -0.37], [0.25, -0.05], [0, 0]]
    ],
    31: [
        [[1, 0], [0, 0], [0, -0.55], [-0.15, -0.55], [-0.25, -0.55], [-0.63, -0.86], [-0.74, -1.39], [-0.48, -1.83], [0, -2], [0.49, -1.83], [0.74, -1.38], [0.65, -0.87], [0.26, -0.55], [0.11, -0.55], [0, -0.55]]
    ],
    32: [
        [[0.5, 0], [0.5, -1.5]],
        [[-0.5, -1.5], [-0.5, 0]]
    ],
    33: [
        [[-1, 0], [0, -1], [1, 0]]
    ],
    34: [
        [[-0.75, 0], [0, -4], [0.75, 0], [1.75, 0]]
    ],
    35: [
        [[0, -0.5], [0, 0], [0.75, 0]],
        [[-0.75, -0.5], [0, -4.5], [0.75, -0.5]]
    ],
    36: [
        [[0, -0.5], [0, 0], [0.75, 0]],
        [[-0.75, -0.5], [-0.75, -3.8], [-0.3, -4.45], [0.3, -4.45], [0.75, -3.8], [0.75, -0.5]]
    ],
    37: [
        [[1.25, 0], [0, 0], [-0.25, -0.05], [-0.65, -0.38], [-0.74, -0.88], [-0.48, -1.33], [0, -1.5], [0.49, -1.33], [0.73, -0.88], [0.65, -0.36], [0.26, -0.05], [0, 0], [0.5, -0.05], [0.89, -0.37], [0.99, -0.88], [0.73, -1.33], [0.25, -1.5], [0.13, -1.46]]
    ],
    38: [
        [[-1, 0], [-1, -0.5], [-0.8, -1.1], [-0.3, -1.45], [0.3, -1.45], [0.8, -1.1], [1, -0.5], [1, 0], [3, 0]]
    ],
    39: [
        [[-0.05, 0], [0.05, 0]],
        [[-1, -1], [-0.81, -1.59], [-0.31, -1.95], [0.3, -1.95], [0.81, -1.59], [1.01, -1.01], [1.29, -0.95], [1.82, -0.59], [2, 0], [1.8, 0.6], [1.3, 0.95], [1, 1], [0.8, 1.6], [0.3, 1.95], [-0.3, 1.95], [-0.8, 1.6], [-1, 1], [-1.3, 0.95], [-1.8, 0.6], [-2, 0], [-1.8, -0.6], [-1.3, -0.95], [-1, -1]]
    ],
    40: [
        [[0.85, 0], [0.95, 0]],
        [[-0.95, 0], [-0.85, 0]],
        [[-1, -1.5], [0, 0], [1, -1.5]]
    ],
    41: [
        [[-1, -1], [1, -1]]
    ],
    42: [
        [[-0.5, -1.5], [-0.4, -1.8], [0, -2], [0.4, -1.8], [0.5, -1.5], [0.5, -0.5], [0.4, -0.2], [0, 0], [-0.4, -0.2], [-0.5, -0.5], [-0.5, -1.5]],
        [[-1, -1], [0.5, -1], [1, -1]]
    ],
    43: [
        [[-0.75, -2], [-0.5, 0]],
        [[0, 0], [0, -3]],
        [[0.75, -2], [0.5, 0]]
    ],
    44: [
        [[0, -2], [0, -3]],
        [[0, 0], [0, -1], [-0.75, -1], [-0.75, -2], [0.75, -2], [0.75, -1], [0, -1]]
    ],
    45: [
        [[-0.17, 0], [-0.09, -0.15], [0.06, -0.15], [0.09, -0.15], [0.17, 0], [0.09, 0.15], [-0.06, 0.15], [-0.09, 0.15], [-0.17, 0]]
    ],
    46: [
        [[-0.5, 0], [0.5, 0]]
    ],
    47: [
        [[-0.25, 0], [-0.13, -0.22], [0.02, -0.22], [0.13, -0.22], [0.25, 0], [0.13, 0.22], [-0.02, 0.22], [-0.13, 0.22], [-0.25, 0], [0.25, 0]]
    ],
    48: [
        [[0, -0.5], [0.4, -0.31], [0.48, 0.1], [0.22, 0.45], [-0.21, 0.45], [-0.49, 0.1], [-0.39, -0.31], [0, -0.5], [-0.15, -0.35], [-0.3, -0.2], [0.3, -0.2], [0.35, 0.1], [-0.4, 0.1]]
    ],
    49: [
        [[0.55, 0.55], [-0.2, -0.2], [-0.55, -0.55]],
        [[-0.55, 0.55], [0.2, -0.2], [0.55, -0.55]]
    ],
    50: [
        [[0.75, -0.5], [-0.75, -0.5]],
        [[0, 1.5], [0, -1.5]]
    ],
    51: [
        [[-0.05, 0], [0.05, 0]],
        [[0.75, -2.5], [0, -2.5], [-0.75, -2.5]],
        [[0, -0.5], [0.4, -0.3], [0.5, 0.1], [0.2, 0.45], [-0.2, 0.45], [-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0, -3.5]]
    ],
    52: [
        [[0, -2.1], [-1.7, 1], [1.6, 1], [0, -2.1]],
        [[-1.7, -1.1], [1.7, -1.1], [0, 1.9], [-1.7, -1.1]]
    ],
    53: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [0.39, -0.31], [0.49, 0.11], [0.21, 0.45], [-0.22, 0.45], [-0.48, 0.11], [-0.39, -0.31], [0, -0.5]]
    ],
    54: [
        [[0, -2], [0, -3]],
        [[-0.5, 0], [-0.5, -2], [0.5, -2], [0.5, 0]]
    ],
    55: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -2], [0, -3]],
        [[-0.5, 0.1], [-0.5, -1.17], [-0.5, -2], [0.5, -2], [0.5, -0.73], [0.5, 0.1], [0.22, 0.44], [-0.2, 0.44], [-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0.4, -0.3], [0.5, 0.1]]
    ],
    56: [
        [[0, -3], [0, 0]],
        [[-0.5, -2], [0, -3], [0.5, -2]]
    ],
    57: [
        [[-0.05, 0], [0.05, 0]],
        [[0.5, -2.5], [0, -3.5], [-0.5, -2.5]],
        [[0, -0.5], [-0.4, -0.3], [-0.48, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [0, -1.77], [0, -3.04], [0, -3.5]]
    ],
    58: [
        [[-0.5, 0], [-0.5, -1.5], [-0.5, -2.4], [-0.4, -2.8], [0, -3], [0.4, -2.8], [0.5, -2.4], [0.5, -0.9], [0.5, 0]]
    ],
    59: [
        [[-0.05, 0], [0.05, 0]],
        [[-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0.4, -0.3], [0.5, 0.1], [0.2, 0.45], [-0.2, 0.45], [-0.5, 0.1], [-0.5, -2.4], [-0.4, -2.8], [0, -3], [0.4, -2.8], [0.5, -2.4], [0.5, 0.1]]
    ],
    60: [
        [[1, -3], [0, -2], [-1, -3]],
        [[0, 0], [0, -3]]
    ],
    61: [
        [[-0.05, 0], [0.05, 0]],
        [[1, -3.5], [0.25, -2.75], [0, -2.5], [-0.75, -3.25], [-1, -3.5]],
        [[0, -0.5], [0.4, -0.3], [0.5, 0.1], [0.2, 0.45], [-0.2, 0.45], [-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0, -3.5]]
    ],
    62: [
        [[-1, -2.3], [0.5, -2.3], [1, -2.3], [1, -1], [0, -1], [0, 0]]
    ],
    63: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [0.4, -0.3], [0.5, 0.1], [0.2, 0.45], [-0.2, 0.45], [-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0, -1.25], [0, -1.5], [0.75, -1.5], [1, -1.5], [1, -2.25], [1, -2.8], [-1, -2.8]]
    ],
    64: [
        [[-0.05, 0], [0.05, 0]],
        [[-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0.4, -0.3], [0.5, 0.1], [0.2, 0.45], [-0.2, 0.45], [-0.5, 0.1], [-0.25, -2.5], [0.25, -2.5], [0.5, 0.1]]
    ],
    65: [
        [[0, -4], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [-0.35, -0.15], [0.35, -0.15], [0.35, 0.15], [-0.35, 0.15]],
        [[1, -4], [-1, -2]],
        [[-1, -4], [1, -2]]
    ],
    66: [
        [[0, -1], [-0.5, -1], [-0.5, -3], [0.5, -3], [0.5, -1], [0, -1]]
    ],
    67: [
        [[-0.7, 0.7]]
    ],
    68: [
        [[0.7, 0.7]]
    ],
    69: [
        [[0.7, -0.7]]
    ],
    70: [
        [[-0.7, -0.7]]
    ],
    71: [
        [[-0.7, -0.7], [0, 0], [-0.7, 0.7]]
    ],
    72: [
        [[0.7, -0.7], [0, 0], [0.7, 0.7]]
    ],
    73: [
        [[-1, -0.5], [1, -0.5]]
    ],
    74: [
        [[1.5, -0.1], [1.5, 0.65], [1.5, 0.7]],
        [[1.5, -0.8], [1.1, 0.2], [1.7, 0.2]],
        [[0.25, -0.55], [0.4, -0.75], [0.6, -0.75], [0.75, -0.55], [0.25, 0.7], [0.75, 0.7]],
        [[-0.4, -0.8], [-0.8, -0.8], [-0.8, -0.15], [-0.7, -0.25], [-0.5, -0.25], [-0.35, -0.05], [-0.35, 0.45], [-0.5, 0.7], [-0.7, 0.7], [-0.85, 0.45]],
        [[-1.7, -0.5], [-1.5, -0.8], [-1.5, -0.05], [-1.5, 0.7]]
    ],
    75: [
        [[0.95, -0.55], [1.08, -0.78], [1.23, -0.78], [1.33, -0.78], [1.45, -0.55], [1.45, 0.45], [1.33, 0.66], [1.18, 0.66], [1.07, 0.66], [0.95, 0.45], [0.95, -0.55]],
        [[0.05, 0.45], [0.05, -0.55], [0.18, -0.77], [0.33, -0.77], [0.43, -0.77], [0.55, -0.55], [0.55, 0.45], [0.42, 0.66], [0.27, 0.66], [0.18, 0.66], [0.05, 0.45]],
        [[-0.85, -0.55], [-0.72, -0.78], [-0.47, -0.77], [-0.35, -0.55], [-0.35, 0.45], [-0.47, 0.66], [-0.62, 0.66], [-0.72, 0.66], [-0.85, 0.45], [-0.85, -0.55]],
        [[-1.5, -0.5], [-1.3, -0.8], [-1.3, 0.47], [-1.3, 0.7]]
    ],
    76: [
        [[0.95, -0.45], [1.08, -0.67], [1.23, -0.67], [1.33, -0.67], [1.45, -0.45], [1.45, 0.55], [1.375, 0.7], [1.34, 0.77], [1.08, 0.76], [0.95, 0.55], [0.95, -0.45]],
        [[0.25, -0.45], [0.13, -0.67], [-0.02, -0.67], [-0.13, -0.67], [-0.25, -0.45], [-0.25, 0.55], [-0.12, 0.77], [0.03, 0.77], [0.12, 0.77], [0.25, 0.55], [0.25, 0.1], [0.13, -0.13], [-0.12, -0.12], [-0.25, 0.1]],
        [[-1.4, -0.7], [-0.9, -0.7], [-1.32, 0.57], [-1.4, 0.8]]
    ],
    77: [
        [[0.95, 0.55], [0.95, -0.45], [1.08, -0.67], [1.33, -0.68], [1.45, -0.45], [1.45, 0.55], [1.33, 0.77], [1.18, 0.77], [1.08, 0.77], [0.95, 0.55]],
        [[0.2, -0.7], [-0.2, -0.7], [-0.2, -0.05], [-0.12, -0.17], [0.03, -0.17], [0.13, -0.17], [0.25, 0.05], [0.25, 0.55], [0.175, 0.7], [0.14, 0.77], [-0.01, 0.77], [-0.12, 0.77], [-0.25, 0.55]],
        [[-1.5, -0.7], [-1, -0.7], [-1.42, 0.57], [-1.5, 0.8]]
    ],
    78: [
        [[0, -0.5], [0, 0.25], [0, 0.5], [0.75, 0.125], [1, 0], [0.25, -0.375], [0, -0.5], [0.1, -0.15], [0.55, -0.15], [0.55, 0.15], [0.1, 0.15]]
    ],
    79: [
        [[0, -0.5], [0, 0.25], [0, 0.5], [-0.75, 0.125], [-1, 0], [-0.25, -0.375], [0, -0.5], [-0.1, -0.15], [-0.55, -0.15], [-0.55, 0.15], [-0.1, 0.15]]
    ],
    80: [
        [[0, -4], [0, -4.75], [0, -5]],
        [[0, 0], [0, -0.75], [0, -1], [-0.75, -1.2], [-1.3, -1.7], [-1.5, -2.5], [-1.3, -3.3], [-0.75, -3.8], [0, -4], [0.75, -3.8], [1.3, -3.25], [1.5, -2.5], [1.3, -1.75], [0.75, -1.2], [0, -1]]
    ],
    81: [
        [[2.8, -2.8], [3.5, -3.5]],
        [[-0.7, -0.7], [0, 0], [0.7, -0.7], [0.3, -1.35], [0.3, -2.1], [0.3, -2.15], [0.7, -2.8], [1.35, -3.2], [2.1, -3.2], [2.15, -3.2], [2.8, -2.8], [3.2, -2.15], [3.2, -1.4], [3.2, -1.35], [2.8, -0.7], [2.15, -0.3], [1.4, -0.3], [1.35, -0.3], [0.7, -0.7]],
        [[-3.5, -3.5], [-2.8, -2.8], [-2.15, -3.2], [-1.4, -3.2], [-1.35, -3.2], [-0.7, -2.8], [-0.3, -2.1], [-0.3, -1.35], [-0.7, -0.7], [-1.35, -0.3], [-2.1, -0.3], [-2.15, -0.3], [-2.8, -0.7], [-3.2, -1.35], [-3.2, -2.1], [-3.2, -2.15], [-2.8, -2.8]]
    ],
    82: [
        [[1.4, -3], [-1.5, -5], [-1.25, -4.7], [-2, -4.7], [-2.4, -4.7], [-2.4, -4.4], [-0.75, -4.4], [-0.35, -4.1], [-2.4, -4.1], [-2.4, -3.8], [-0.5, -3.8], [-0.95, -3.5], [-1.7, -3.5], [-2.4, -3.5], [-2.4, -3.2], [-1.65, -3.2], [-1.4, -3.2], [-1.5, -3], [1.4, -5], [1.15, -4.7], [1.9, -4.7], [2.4, -4.7], [2.4, -4.4], [0.7, -4.4], [0.25, -4.1], [2.4, -4.1], [2.4, -3.8], [0.4, -3.8], [0.85, -3.5], [2.4, -3.5], [2.4, -3.2], [1.65, -3.2], [1.3, -3.2]],
        [[0, 0], [0, -3], [2.5, -3], [2.5, -5], [-2.5, -5], [-2.5, -3], [0, -3]]
    ],
    83: [
        [[0, -0.4], [0.32, -0.25], [0.39, 0.09], [0.17, 0.36], [-0.17, 0.36], [-0.39, 0.09], [-0.31, -0.25], [0, -0.4]]
    ],
    84: [
        [[0, -0.5], [0, 0.5]]
    ],
    85: [
        [[0, 1], [0, -1]],
        [[-0.5, -1], [0.5, -1], [0.5, 1], [-0.5, 1]]
    ],
    86: [
        [[0, -5], [-0.5, -5], [-0.5, -5.75], [-0.5, -5.9], [3, -5.9], [3, -5.15], [3, -5], [0, -5], [-0.35, -5.3], [2.85, -5.3], [2.85, -5.6], [-0.35, -5.6]],
        [[-0.5, 0], [0.25, 0], [0.5, 0]]
    ],
    87: [
        [[0, -2], [-0.6, -2.2], [-0.95, -2.7], [-0.95, -3.35], [-0.6, -3.8], [0, -4], [0.6, -3.8], [0.95, -3.3], [0.95, -2.7], [0.6, -2.2], [0, -2]],
        [[-0.5, 0], [0.25, 0], [0.5, 0]]
    ],
    88: [
        [[7, 0], [0.65, 0], [0, 0], [0, -0.5], [2, -0.5], [2, 0], [1.9, -0.25], [0.1, -0.25]]
    ],
    89: [
        [[-7, 0], [-0.65, 0], [0, 0], [0, -0.5], [-2, -0.5], [-2, 0], [-1.9, -0.25], [-0.1, -0.25]]
    ],
    90: [
        [[7, 0], [0.65, 0], [0, 0], [0, 0.5], [2, 0.5], [2, 0], [1.9, 0.25], [0.1, 0.25]]
    ],
    91: [
        [[-7, 0], [-0.65, 0], [0, 0], [0, 0.5], [-2, 0.5], [-2, 0], [-1.9, 0.25], [-0.1, 0.25]]
    ],
    92: [
        [[-0.5, 0], [0.25, 0], [0.5, 0]],
        [[0, -2.95], [0, 0]],
        [[-0.5, -2.2], [2, -6]],
        [[-2, -6], [0.5, -2.2]]
    ],
    93: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [0.4, -0.3], [0.49, 0.11], [0.22, 0.45], [-0.21, 0.45], [-0.49, 0.11], [-0.4, -0.3], [0, -0.5]]
    ],
    94: [
        [[-1, 0], [1, 0], [0.8, 0.6], [0.3, 0.95], [-0.3, 0.95], [-0.8, 0.6], [-1, 0]]
    ],
    95: [
        [[-1, 0], [-0.8, -0.6], [-0.3, -0.95], [0.3, -0.95], [0.8, -0.6], [1, 0]]
    ],
    96: [
        [[1.5, -0.75], [3.5, 0], [1.5, 0.75]],
        [[-2.75, 0], [3.5, 0]],
        [[-3.5, -0.75], [-3.5, 0], [-3.5, 0.75], [-3.1, 0.75], [-2.85, 0.65], [-2.75, 0.4], [-2.75, -0.35], [-2.75, -0.4], [-2.85, -0.65], [-3.1, -0.75], [-3.5, -0.75]]
    ],
    97: [
        [[0, -1.5], [0, -3], [1.5, -3], [2, -3], [2, -1.8], [0.5, -1.8], [0, -1.8]],
        [[-0.5, 0], [0.5, 0]]
    ],
    98: [
        [[0, -3], [2, -3], [2, -1.8], [0, -1.8]]
    ],
    99: [
        [[0.5, 0], [-0.5, 0]],
        [[-1, -2], [1, -2]],
        [[1, -3], [-1, -3]],
        [[-1, -4], [1, -4]]
    ],
    100: [
        [[-1, -2], [1, -2]],
        [[1, -3], [-1, -3]],
        [[-1, -4], [1, -4]],
        [[0, 0], [0, -4]]
    ],
    101: [
        [[0, -1.5], [1.5, -1.5], [1.5, -3], [-1.5, -3], [-1.5, -1.5], [0, -1.5]],
        [[-0.5, 0], [0.5, 0]]
    ],
    102: [
        [[0, -2], [1, -2], [0, -3.75], [-1, -2], [0, -2]],
        [[-0.5, 0], [0.5, 0]]
    ],
    103: [
        [[0, -2], [1, -2], [0, -3.75], [-1, -2], [0, -2]]
    ],
    104: [
        [[0.5, 0], [0.5, -2], [-0.5, -2], [-0.5, 0]],
        [[-1.5, 0], [1.5, 0]]
    ],
    105: [
        [[1, -1]]
    ],
    106: [
        [[-3.2, 1], [-2.2, 0], [0.8, 0], [2.2, 0], [3.2, -1]]
    ],
    107: [
        [[-0.25, 0], [-0.12, -0.22], [0.03, -0.22], [0.13, -0.22], [0.25, 0], [0.12, 0.22], [-0.03, 0.22], [-0.13, 0.22], [-0.25, 0], [0.25, 0]]
    ],
    108: [
        [[0, -0.5], [0.4, -0.3], [0.48, 0.1], [0.22, 0.45], [-0.22, 0.45], [-0.49, 0.1], [-0.39, -0.31], [0, -0.5], [0.35, -0.15], [-0.35, -0.15], [-0.35, 0], [-0.35, 0.15], [0.35, 0.15]]
    ],
    109: [
        [[-0.5, -0.5], [0.25, -0.5], [0.5, -0.5], [0.5, 0.25], [0.5, 0.5], [-0.25, 0.5], [-0.5, 0.5], [-0.5, -0.25], [-0.5, -0.5], [-0.4, -0.15], [0.35, -0.15], [0.4, -0.15], [0.4, 0.15], [-0.35, 0.15], [-0.4, 0.15]]
    ],
    110: [
        [[0.35, -0.8], [-0.35, -0.8], [-0.1, -1.1], [0.1, -1.1]],
        [[-0.75, 0], [-0.375, -0.75], [0, -1.5], [0.375, -0.75], [0.75, 0]]
    ],
    111: [
        [[0.5, -0.5], [-0.25, -0.5], [-0.5, -0.5], [-0.5, 0.25], [-0.5, 0.5], [0.25, 0.5], [0.5, 0.5], [0.5, -0.25], [0.5, -0.5], [0.4, -0.15], [-0.35, -0.15], [-0.4, -0.15], [-0.4, 0.2], [0.35, 0.2], [0.4, 0.2]],
        [[-0.5, -2], [0.25, -2], [0.5, -2], [0, -3.5], [-0.5, -2], [0, -0.5], [0.5, -2]]
    ],
    112: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    113: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    114: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    115: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    116: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    117: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    118: [
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    119: [
        [[-1, 0.75], [-1, -0.75]],
        [[0.75, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0.75]],
        [[-0.75, -1], [0.75, -1]]
    ],
    120: [
        [[-1, 0.75], [-1, -0.75]],
        [[0.75, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0.75]],
        [[-0.75, -1], [0.75, -1]]
    ],
    121: [
        [[-1, 0.75], [-1, -0.75]],
        [[0.75, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0.75]],
        [[-0.75, -1], [0.75, -1]]
    ],
    122: [
        [[-1, 0.75], [-1, -0.75]],
        [[0.75, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0.75]],
        [[-0.75, -1], [0.75, -1]]
    ],
    123: [
        [[-1, 0.75], [-1, 0], [-1, -0.75]],
        [[0.75, 1], [0, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0], [1, 0.75]],
        [[-0.7, -1], [0.05, -1], [0.75, -1]]
    ],
    124: [
        [[-1, 0.75], [-1, -0.75]],
        [[0.75, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0.75]],
        [[-0.75, -1], [0.75, -1]]
    ],
    125: [
        [[-1, 0.75], [-1, -0.75]],
        [[0.75, 1], [-0.75, 1]],
        [[1, -0.75], [1, 0.75]],
        [[-0.75, -1], [0.75, -1]]
    ],
    126: [
        [[0, -2.5], [0, -1], [1, -1], [1, 0.5], [1, 1], [-0.5, 1], [-1, 1], [-1, -0.5], [-1, -1], [0, -1]],
        [[-0.4, -1.9], [0, -2.5], [0.4, -1.9]]
    ],
    127: [
        [[0, -0.75], [0, -1], [0.75, -1], [1, -1], [1, -3], [-1, -3], [-1, -1], [-0.25, -1], [0, -1], [0.9, -1.3], [-0.9, -1.3], [-0.9, -1.65], [0.9, -1.65], [1, -2], [-1, -2]]
    ],
    128: [
        [[-0.5, -1.75], [0.5, -1.75]],
        [[0, -0.75], [-0.49, -0.58], [-0.74, -0.14], [-0.65, 0.39], [-0.24, 0.71], [0.25, 0.7], [0.65, 0.38], [0.74, -0.14], [0.48, -0.58], [0, -0.75], [0, -1.75]]
    ],
    129: [
        [[0.5, -0.5], [-0.5, 0.5]],
        [[0, -1.75], [0, -0.75], [-0.49, -0.59], [-0.74, -0.15], [-0.66, 0.38], [-0.25, 0.7], [0.26, 0.7], [0.65, 0.38], [0.74, -0.14], [0.48, -0.57], [0, -0.75]],
        [[-0.5, -1.75], [0.5, -1.75]]
    ],
    130: [
        [[0, -0.5], [0.39, -0.31], [0.49, 0.11], [0.22, 0.45], [-0.21, 0.45], [-0.49, 0.1], [-0.39, -0.31], [0, -0.5]]
    ],
    131: [
        [[0, -0.5], [0.39, -0.31], [0.48, 0.11], [0.22, 0.45], [-0.21, 0.45], [-0.48, 0.12], [-0.39, -0.31], [0, -0.5]]
    ],
    132: [
        [[1.5, -0.75], [3.5, 0], [1.5, 0.75]],
        [[-3.5, 0], [0.25, 0], [3.5, 0]]
    ],
    133: [
        [[1.5, -0.75], [3.5, 0], [1.5, 0.75]],
        [[-1.5, 0], [-1.7, -0.6], [-2.2, -0.95], [-2.8, -0.95], [-3.3, -0.6], [-3.5, 0], [2.85, 0], [3.5, 0]]
    ],
    134: [
        [[3.5, 0], [-2.85, 0], [-3.5, 0], [-3.3, -0.65], [-2.85, -0.95], [-2.2, -0.95], [-1.7, -0.6], [-1.5, 0], [-1.75, -0.3], [-2.5, -0.3], [-3.25, -0.3], [-3.15, -0.6], [-2.4, -0.6], [-1.85, -0.6]],
        [[1.5, -0.75], [3.5, 0], [1.5, 0.75]]
    ],
    135: [
        [[0, 1.5], [0, 2], [1.5, 2], [3, 2], [2.3, 1.3], [2.3, 2.7], [3, 2], [2.6, 1.7], [2.4, 1.7], [2.4, 2.3], [2.6, 2.3]]
    ],
    136: [
        [[0, -0.7], [0.7, 0], [0, 0.7], [-0.7, 0], [0, -0.7], [0.15, -0.4], [-0.15, -0.4], [-0.45, -0.1], [0.3, -0.1], [0.5, -0.1], [0.35, 0.2], [-0.35, 0.2], [-0.1, 0.45], [0.1, 0.45]]
    ],
    137: [
        [[-0.3, 0.95], [-0.8, 0.6], [-1, 0], [-0.8, -0.6], [-0.3, -0.95], [0.3, -0.95], [0.8, -0.6], [1, 0], [0.8, 0.6], [0.3, 0.95], [-0.3, 0.95]]
    ],
    138: [
        [[0, 1], [0.6, 0.8], [0.95, 0.3], [0.95, -0.3], [0.6, -0.8], [0, -1], [-0.6, -0.8], [-0.95, -0.3], [-0.95, 0.3], [-0.6, 0.8], [0, 1], [0, -2]]
    ],
    139: [
        [[0.7, -0.7], [0.99, -0.16], [0.89, 0.46], [0.45, 0.89], [-0.16, 0.98], [-0.7, 0.7], [-0.98, 0.16], [-0.88, -0.47], [-0.45, -0.89], [0.17, -0.99], [0.7, -0.7], [-0.57, 0.57], [-0.7, 0.7]]
    ],
    140: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, -1], [-3.2, -0.95], [-2.7, -0.6], [-2.5, 0], [-2.7, 0.6], [-3.2, 0.95], [-3.5, 1]]
    ],
    141: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, -1], [3.2, -0.95], [2.7, -0.6], [2.5, 0], [2.7, 0.6], [3.2, 0.95], [3.5, 1]]
    ],
    142: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, -1], [-3.2, -0.95], [-2.7, -0.6], [-2.5, 0], [-2.7, 0.6], [-3.2, 0.95], [-3.5, 1]],
        [[-1.4, 1], [-0.65, 0.25], [-0.4, 0], [-1.15, -0.75], [-1.4, -1]],
        [[0.5, -1], [0.8, -0.95], [1.3, -0.6], [1.5, 0], [1.3, 0.6], [0.8, 0.95], [0.5, 1]]
    ],
    143: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, 1], [3.2, 0.95], [2.7, 0.6], [2.5, 0], [2.7, -0.6], [3.2, -0.95], [3.5, -1]],
        [[1.4, -1], [0.65, -0.25], [0.4, 0], [1.15, 0.75], [1.4, 1]],
        [[-0.5, -1], [-0.85, -0.95], [-1.3, -0.6], [-1.5, 0], [-1.3, 0.6], [-0.85, 0.95], [-0.5, 1]]
    ],
    144: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, -1], [-3.2, -0.95], [-2.7, -0.6], [-2.5, 0], [-2.7, 0.6], [-3.2, 0.95], [-3.5, 1]],
        [[-1.1, 0.6], [-0.5, 0], [-1.1, -0.6]],
        [[1, -0.6], [1.5, 0], [1, 0.6]]
    ],
    145: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, -1], [3.2, -0.95], [2.7, -0.6], [2.5, 0], [2.7, 0.6], [3.2, 0.95], [3.5, 1]],
        [[1.1, 0.6], [0.5, 0], [1.1, -0.6]],
        [[-1, -0.6], [-1.5, 0], [-1, 0.6]]
    ],
    146: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, 1], [-3.2, 0.95], [-2.7, 0.6], [-2.5, 0], [-2.7, -0.6], [-3.2, -0.95], [-3.5, -1]],
        [[-1.5, -1], [-0.75, -0.25], [-0.5, 0], [-1.25, 0.75], [-1.5, 1]]
    ],
    147: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, 1], [3.2, 0.95], [2.7, 0.6], [2.5, 0], [2.7, -0.6], [3.2, -0.95], [3.5, -1]],
        [[1.5, -1], [0.75, -0.25], [0.5, 0], [1.25, 0.75], [1.5, 1]]
    ],
    148: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, 1], [-3.2, 0.95], [-2.7, 0.6], [-2.5, 0], [-2.7, -0.6], [-3.2, -0.95], [-3.5, -1]],
        [[0.5, -1], [0.8, -0.95], [1.3, -0.6], [1.5, 0], [1.3, 0.6], [0.8, 0.95], [0.5, 1]]
    ],
    149: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, 1], [3.2, 0.95], [2.7, 0.6], [2.5, 0], [2.7, -0.6], [3.2, -0.95], [3.5, -1]],
        [[-0.5, -1], [-0.8, -0.95], [-1.3, -0.6], [-1.5, 0], [-1.3, 0.6], [-0.85, 0.95], [-0.5, 1]]
    ],
    150: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, 1], [-3.2, 0.95], [-2.7, 0.6], [-2.5, 0], [-2.7, -0.6], [-3.2, -0.95], [-3.5, -1]],
        [[-0.5, -1], [0.25, -1], [0.5, -1], [0.5, 1], [-0.25, 1], [-0.5, 1]]
    ],
    151: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, 1], [3.2, 0.95], [2.7, 0.6], [2.5, 0], [2.7, -0.6], [3.2, -0.95], [3.5, -1]],
        [[0.5, -1], [-0.25, -1], [-0.5, -1], [-0.5, 1], [0.25, 1], [0.5, 1]]
    ],
    152: [
        [[-2.5, 0], [3.5, 0]],
        [[-3.5, -1], [-3.2, -0.95], [-2.7, -0.6], [-2.5, 0], [-2.7, 0.6], [-3.2, 0.95], [-3.5, 1]],
        [[-1.5, 1], [-0.75, 0.25], [-0.5, 0], [-1.25, -0.75], [-1.5, -1]],
        [[0.6, -1], [1.5, 0], [0.75, 0.75], [0.5, 1]]
    ],
    153: [
        [[2.5, 0], [-3.5, 0]],
        [[3.5, -1], [3.15, -0.95], [2.7, -0.6], [2.5, 0], [2.7, 0.6], [3.2, 0.95], [3.5, 1]],
        [[1.5, 1], [0.75, 0.25], [0.5, 0], [1.25, -0.75], [1.5, -1]],
        [[-0.5, -1], [-1.25, -0.25], [-1.5, 0], [-0.6, 1]]
    ],
    154: [
        [[-0.5, 0], [-0.5, -0.5], [0.5, -0.5], [0.5, 0.5], [-0.5, 0.5], [-0.5, 0], [0.5, 0]]
    ],
    155: [
        [[-0.5, 0], [-0.5, -0.5], [0.5, -0.5], [0.5, 0.5], [-0.5, 0.5], [-0.5, 0], [0.5, 0]]
    ],
    156: [
        [[-0.6, -0.8], [0, -1], [0.6, -0.8], [0.95, -0.3], [0.95, 0.3], [0.6, 0.8], [0, 1], [-0.6, 0.8], [-0.95, 0.3], [-0.95, -0.3], [-0.6, -0.8], [0, 1], [0.6, -0.8]]
    ],
    157: [
        [[-3.5, 0], [-1.5, 0], [-1.5, 1], [1.5, 1], [1.5, 0], [3.5, 0]]
    ],
    158: [
        [[-3.5, 0], [-1.5, 0], [-1.5, 1], [1.5, 1], [1.5, 0], [3.5, 0]]
    ],
    159: [
        [[-0.75, 1], [-0.75, 0]],
        [[0.75, 0], [0.75, 1]],
        [[-3.5, 0], [-1.5, 0], [-1.5, 1], [1.5, 1], [1.5, 0], [3.5, 0]]
    ],
    160: [
        [[-0.75, 0], [-0.75, 1]],
        [[0, 1], [0, 0]],
        [[0.75, 0], [0.75, 1]],
        [[-3.5, 0], [-1.5, 0], [-1.5, 1], [1.5, 1], [1.5, 0], [3.5, 0]]
    ],
    161: [
        [[1.5, 0], [1.25, -0.8], [0.75, -1.3], [0, -1.5], [-0.8, -1.25], [-1.3, -0.75], [-1.5, 0]],
        [[-3.5, 0], [2.85, 0], [3.5, 0]]
    ],
    162: [
        [[-1.5, 0], [-1.3, -0.75], [-0.75, -1.3], [0, -1.5], [0.75, -1.3], [1.3, -0.75], [1.5, 0]]
    ],
    163: [
        [[0.4, 0.3], [1, 1.05]],
        [[-1, 1.05], [-0.4, 0.3], [-0.5, -0.1], [-0.2, -0.45], [0.2, -0.45], [0.5, -0.1], [0.4, 0.3], [0, 0.5], [-0.4, 0.3]]
    ],
    164: [
        [[0, -4], [1.7, -3], [0, -2]]
    ],
    165: [
        [[0.25, 1], [0.25, -1]],
        [[-0.25, -1], [-0.25, 1]]
    ],
    166: [
        [[0, -0.75], [0.49, -0.58], [0.73, -0.13], [0.65, 0.38], [0.26, 0.71], [-0.24, 0.71], [-0.64, 0.38], [-0.74, -0.13], [-0.48, -0.57], [0, -0.75], [0.4, -0.5], [-0.35, -0.5], [-0.55, -0.2], [0.55, -0.2], [0.55, -0.05], [0.55, 0.1], [-0.55, 0.1], [-0.45, 0.4], [0.45, 0.4]]
    ],
    167: [
        [[-0.4, -0.7], [0.1, -0.7], [0.4, -0.4], [0.4, 0.35], [0.4, 0.5], [0.1, 0.8], [-0.4, 0.8], [-0.4, 0.05], [-0.4, -0.7]],
        [[-2, 1.3], [2, 1.3], [0, -2.15], [-2, 1.3]]
    ],
    168: [
        [[-0.5, 0.6], [-0.25, 0.95], [0.2, 0.95], [0.4, 0.6], [0.2, 0.1], [-0.25, -0.1], [-0.4, -0.55], [-0.2, -0.9], [0.2, -0.9], [0.4, -0.55]],
        [[-2, 1.5], [2, 1.5], [0, -1.95], [-2, 1.5]]
    ],
    169: [
        [[-1, 0.8], [1, 0.8], [0, -0.9], [-1, 0.8], [-0.7, 0.5], [0.05, 0.5], [0.7, 0.5], [0.5, 0.2], [-0.25, 0.2], [-0.5, 0.2], [-0.3, -0.1], [0.35, -0.1], [0.15, -0.4], [-0.15, -0.4], [-0.05, -0.6], [0.1, -0.6]]
    ],
    170: [
        [[0.45, -1.8], [0, -2.25], [-0.45, -1.8]],
        [[0, -0.75], [-0.49, -0.58], [-0.75, -0.1], [-0.65, 0.38], [-0.24, 0.7], [0.27, 0.7], [0.66, 0.37], [0.74, -0.14], [0.48, -0.58], [0, -0.75], [0, -2.02], [0, -2.25]]
    ],
    171: [
        [[-0.5, -1], [-0.5, 1], [0.25, 0.25], [0.5, 0], [-0.25, -0.75], [-0.5, -1], [-0.4, -0.7], [-0.3, -0.7], [-0.05, -0.4], [-0.4, -0.4], [-0.4, -0.1], [0.3, -0.1], [0.2, 0.2], [-0.4, 0.2], [-0.4, 0.5], [-0.1, 0.5], [-0.4, 0.8]]
    ],
    172: [
        [[0.3, 0.2], [-0.3, 0.2]],
        [[-0.5, 0.7], [0, -0.8], [0.5, 0.7]],
        [[-1, 1], [0.5, 1], [1, 1], [1, -0.5], [1, -1], [-0.5, -1], [-1, -1], [-1, 0.5], [-1, 1]]
    ],
    173: [
        [[-0.5, -0.8], [-0.5, -0.05], [-0.5, 0.35], [-0.25, 0.7], [0.25, 0.7], [0.5, 0.35], [0.5, -0.4], [0.5, -0.8]],
        [[-1, -1], [1, -1], [1, 1], [-1, 1], [-1, -1]]
    ],
    174: [
        [[-0.75, 0], [-0.75, 0.7], [0, 0.7], [0.75, 0.7], [0.75, 0]]
    ],
    175: [
        [[-0.75, 0], [-0.75, -0.7], [0, -0.7], [0.75, -0.7], [0.75, 0]]
    ],
    176: [
        [[-0.75, -0.7], [0, -0.7], [0.75, -0.7], [0.75, 0.05], [0.75, 0.7], [0, 0.7], [-0.75, 0.7], [-0.75, -0.05], [-0.75, -0.7]]
    ],
    177: [
        [[0, -0.75], [0, 0.75]],
        [[-3.5, 0], [0.25, 0], [3.5, 0]]
    ],
    178: [
        [[0, 0.75], [0, -0.75]],
        [[-3.5, 1.5], [0.25, 1.5], [3.5, 1.5]],
        [[3.5, 0], [-0.25, 0], [-3.5, 0]],
        [[-3.5, -1.5], [0.25, -1.5], [3.5, -1.5]]
    ],
    179: [
        [[3.5, 0], [-0.25, 0], [-3.5, 0]],
        [[1.5, 0.75], [3.5, 0], [1.5, -0.75]],
        [[0, -0.75], [0, 0.75]],
        [[-1.5, 0.75], [-3.5, 0], [-1.5, -0.75]]
    ],
    180: [
        [[-1.5, 0.75], [-3.5, 0], [-1.5, -0.75]],
        [[0, -0.75], [0, 0.75]],
        [[1.5, 0.75], [3.5, 0], [1.5, -0.75]],
        [[-3.5, 1.5], [0.25, 1.5], [3.5, 1.5]],
        [[3.5, 0], [-0.25, 0], [-3.5, 0]],
        [[-3.5, -1.5], [0.25, -1.5], [3.5, -1.5]]
    ],
    181: [
        [[3.5, 0], [-0.25, 0], [-3.5, 0]],
        [[1.5, 0.75], [3.5, 0], [1.5, -0.75]],
        [[0.5, -0.75], [0.5, 0.75]],
        [[-0.5, 0.75], [-0.5, -0.75]],
        [[-1.5, -0.75], [-3.5, 0], [-1.5, 0.75]]
    ],
    182: [
        [[-1.5, -0.75], [-3.5, 0], [-1.5, 0.75]],
        [[-0.5, 0.75], [-0.5, -0.75]],
        [[0.5, -0.75], [0.5, 0.75]],
        [[1.5, 0.75], [3.5, 0], [1.5, -0.75]],
        [[-3.5, 1.5], [0.25, 1.5], [3.5, 1.5]],
        [[3.5, 0], [-0.25, 0], [-3.5, 0]],
        [[-3.5, -1.5], [0.25, -1.5], [3.5, -1.5]]
    ],
    183: [
        [[0, 0.75], [0, 0], [0, -0.75]],
        [[-2, 0], [-2.2, 0.5], [-2.6, 0.7], [-3.1, 0.65], [-3.45, 0.3], [-3.45, -0.25], [-3.15, -0.65], [-2.65, -0.75], [-2.2, -0.5], [-2, 0], [2, 0], [2.2, -0.5], [2.65, -0.75], [3.15, -0.65], [3.45, -0.25], [3.45, 0.25], [3.1, 0.65], [2.6, 0.7], [2.2, 0.5], [2, 0]]
    ],
    184: [
        [[-3.5, 1.5], [-2.23, 1.5], [-0.96, 1.5], [0.31, 1.5], [1.58, 1.5], [2.85, 1.5], [3.5, 1.5]],
        [[3.5, -1.5], [2.23, -1.5], [0.96, -1.5], [-0.31, -1.5], [-1.58, -1.5], [-2.85, -1.5], [-3.5, -1.5]],
        [[0, 0.75], [0, -0.52], [0, -0.75]],
        [[-2, 0], [-2.17, -0.48], [-2.61, -0.73], [-3.12, -0.65], [-3.45, -0.27], [-3.45, 0.24], [-3.13, 0.65], [-2.62, 0.73], [-2.17, 0.49], [-2, 0], [-0.73, 0], [0.54, 0], [1.81, 0], [2, 0], [2.18, -0.49], [2.62, -0.74], [3.13, -0.65], [3.45, -0.26], [3.45, 0.26], [3.13, 0.65], [2.62, 0.74], [2.18, 0.48], [2, 0]]
    ],
    185: [
        [[-3.5, 0], [0.25, 0], [3.5, 0]],
        [[-1, -0.75], [-1, 0.75]],
        [[0, 0.75], [0, -0.75]],
        [[1, -0.75], [1, 0.75]]
    ],
    186: [
        [[1, 0.75], [1, -0.75]],
        [[0, -0.75], [0, 0.75]],
        [[-1, 0.75], [-1, -0.75]],
        [[3.5, 1.5], [-0.25, 1.5], [-3.5, 1.5]],
        [[-3.5, 0], [0.25, 0], [3.5, 0]],
        [[3.5, -1.5], [-0.25, -1.5], [-3.5, -1.5]]
    ],
    187: [
        [[0.48, -3.17], [-0.5, -2.1]],
        [[0.5, -2.1], [-0.46, -3.17]],
        [[0.2, 0.15], [-0.25, 0.15], [-0.25, 0], [-0.25, -0.1], [0.25, -0.1], [0, -0.4], [-0.15, -0.325], [-0.3, -0.25], [-0.4, 0.1], [-0.17, 0.36], [0.18, 0.35], [0.38, 0.1], [0.31, -0.26], [0, -0.4], [0, -1.67], [0, -1.9], [0.51, -2.09], [0.73, -2.53], [0.66, -3.02], [0.24, -3.36], [-0.25, -3.35], [-0.63, -3.04], [-0.74, -2.52], [-0.48, -2.08], [0, -1.9]]
    ],
    188: [
        [[0.48, -2.77], [-0.5, -1.7]],
        [[0.5, -1.7], [-0.46, -2.77]],
        [[0, 0], [0, -1.27], [0, -1.5], [0.48, -1.68], [0.73, -2.11], [0.65, -2.62], [0.27, -2.95], [-0.25, -2.96], [-0.65, -2.63], [-0.74, -2.13], [-0.49, -1.68], [0, -1.5]]
    ],
    189: [
        [[0.47, -3.18], [-0.48, -2.12]],
        [[0.5, -2.1], [-0.47, -3.18]],
        [[-1.5, -1.9], [-0.23, -1.9], [1.04, -1.9], [1.5, -1.9]],
        [[0, -1.9], [0.51, -2.1], [0.73, -2.52], [0.65, -3.05], [0.24, -3.36], [-0.25, -3.36], [-0.65, -3.03], [-0.73, -2.52], [-0.47, -2.08], [0, -1.9], [0, -0.63], [0, -0.4], [-0.15, -0.325], [-0.3, -0.25], [-0.4, 0.1], [-0.2, 0.35], [0.2, 0.35], [0.4, 0.1], [0.3, -0.25], [0.15, -0.325], [0, -0.4], [-0.25, -0.1], [0.25, -0.1], [0.25, 0.05], [0.25, 0.15], [-0.25, 0.15]]
    ],
    190: [
        [[-0.46, -2.77], [0.5, -1.7]],
        [[-0.5, -1.7], [0.48, -2.77]],
        [[1.5, -1.5], [0.23, -1.5], [-1.04, -1.5], [-1.5, -1.5]],
        [[0, 0], [0, -1.27], [0, -1.5], [0.5, -1.7], [0.75, -2.15], [0.63, -2.66], [0.24, -2.97], [-0.27, -2.95], [-0.64, -2.62], [-0.74, -2.11], [-0.5, -1.7], [0, -1.5]]
    ],
    191: [
        [[-1.5, 0], [-0.23, 0], [1.04, 0], [1.5, 0]],
        [[0.47, -1.27], [-0.49, -0.2]],
        [[0.5, -0.21], [-0.47, -1.27]],
        [[0, 0], [0.48, -0.17], [0.74, -0.61], [0.65, -1.13], [0.27, -1.45], [-0.24, -1.46], [-0.64, -1.14], [-0.74, -0.65], [-0.49, -0.18], [0, 0]]
    ],
    192: [
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]]
    ],
    193: [
        [[2, -0.75], [3, 0], [2, 0.75]],
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]]
    ],
    194: [
        [[3.5, 1.5], [-0.25, 1.5], [-3.5, 1.5]],
        [[2, -0.75], [3, 0], [2, 0.75]],
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]],
        [[3.5, -1.5], [-0.25, -1.5], [-3.5, -1.5]]
    ],
    195: [
        [[1, 0.75], [2, 0], [1, -0.75]],
        [[2, -0.75], [3, 0], [2, 0.75]],
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]]
    ],
    196: [
        [[3.5, 1.5], [-0.25, 1.5], [-3.5, 1.5]],
        [[1, 0.75], [2, 0], [1, -0.75]],
        [[2, -0.75], [3, 0], [2, 0.75]],
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]],
        [[3.5, -1.5], [-0.25, -1.5], [-3.5, -1.5]]
    ],
    197: [
        [[0, -0.75], [1, 0], [0, 0.75]],
        [[1, 0.75], [2, 0], [1, -0.75]],
        [[2, -0.75], [3, 0], [2, 0.75]],
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]]
    ],
    198: [
        [[3.5, 1.5], [-0.25, 1.5], [-3.5, 1.5]],
        [[0, -0.75], [1, 0], [0, 0.75]],
        [[1, 0.75], [2, 0], [1, -0.75]],
        [[2, -0.75], [3, 0], [2, 0.75]],
        [[-3, 0], [-2, 0], [-2, -1], [0, 0], [3, 0]],
        [[3.5, -1.5], [-0.25, -1.5], [-3.5, -1.5]]
    ],
    199: [
        [[-1, 2], [1, 2]],
        [[2.5, 1], [-2.5, 1]],
        [[-3.5, 0], [3.5, 0]]
    ],
    200: [
        [[-3.5, 0], [0, -1], [3.5, 0], [0, 1], [-3.5, 0]]
    ],
    201: [
        [[1.2, -1], [0.5, 0], [-0.2, -1]],
        [[-0.5, -4.5], [-0.5, -3], [-0.5, -2], [0.5, -3], [0.5, -1.5], [0.5, 0]]
    ],
    202: [
        [[-1, 0], [-1, -1], [1, -1], [1, 0], [-1, 0]]
    ],
    203: [
        [[-1.5, 0], [1.5, 0], [1.5, -2], [-1.5, -2], [-1.5, 0]],
        [[-1, -0.5], [1, -0.5], [1, -1.5], [-1, -1.5], [-1, -0.5]]
    ],
    204: [
        [[0.8, -1.3], [1.2, -1.3], [1.35, -1.225], [1.5, -1.15], [1.6, -0.8], [1.4, -0.55], [1.15, -0.5], [0.8, -0.5], [0.8, -1.77], [0.8, -2], [0.95, -2], [1.1, -2], [1.4, -1.95], [1.475, -1.8], [1.55, -1.65], [1.475, -1.5], [1.4, -1.35], [1.2, -1.3]],
        [[-1.6, -0.5], [-1.6, -1.77], [-1.6, -2], [-1.2, -2], [-0.95, -1.95], [-0.8, -1.7], [-0.8, -0.8], [-0.95, -0.55], [-1.2, -0.5], [-1.6, -0.5]],
        [[0, -0.4], [0.32, -0.25], [0.4, 0.09], [0.18, 0.36], [-0.16, 0.36], [-0.38, 0.1], [-0.31, -0.26], [0, -0.4], [-0.2, -0.15], [0.2, -0.15], [0.2, 0], [0.2, 0.15], [-0.2, 0.15]],
        [[-2, 0], [-0.73, 0], [0.54, 0], [1.81, 0], [2, 0]]
    ],
    205: [
        [[0, -0.4], [0.15, -0.325], [0.3, -0.25], [0.39, 0.09], [0.18, 0.35], [-0.16, 0.35], [-0.38, 0.1], [-0.31, -0.25], [0, -0.4], [-0.2, -0.15], [0.2, -0.15], [0.2, 0], [0.2, 0.15], [-0.2, 0.15]],
        [[2, 0], [0.73, 0], [-0.54, 0], [-1.81, 0], [-2, 0]],
        [[0.8, -1.3], [1.2, -1.3], [1.35, -1.225], [1.5, -1.15], [1.6, -0.8], [1.4, -0.55], [1.15, -0.5], [0.8, -0.5], [0.8, -1.77], [0.8, -2], [0.95, -2], [1.1, -2], [1.4, -1.95], [1.475, -1.8], [1.55, -1.65], [1.35, -1.35], [1.2, -1.3]],
        [[-1.6, -2], [-0.8, -2], [-1.43, -0.73], [-1.6, -0.4], [-0.8, -0.4]]
    ],
    206: [
        [[-3.1, 0.1], [-2.5, -0.3], [-1.5, -0.5], [-0.5, -0.3], [0, 0], [1, 0.45], [1.75, 0.45], [2, 0.45], [2.75, 0.075], [3.1, -0.1]]
    ],
    207: [
        [[3.5, -1.5], [-2.85, -1.5], [-3.5, -1.5]],
        [[-3.1, 0.1], [-2.5, -0.3], [-1.5, -0.5], [-0.5, -0.3], [0.25, 0.075], [1, 0.45], [1.75, 0.45], [2.05, 0.45], [3.1, -0.1]],
        [[3.5, 1.5], [-2.85, 1.5], [-3.5, 1.5]]
    ],
    208: [
        [[1, -1], [1.4, -0.8], [1.5, -0.45], [1.5, 0.3], [1.5, 0.5], [1.4, 0.8], [1, 1], [0.6, 0.8], [0.5, 0.5], [0.5, -0.25], [0.5, -0.45], [0.6, -0.8], [1, -1]],
        [[-1.5, 1.1], [-1.5, -1], [-0.95, -1], [-0.55, -0.75], [-0.55, -0.25], [-0.95, 0], [-1.5, 0]]
    ],
    209: [
        [[-0.5, -1], [-0.5, 1]],
        [[0.5, -1], [0.5, 1]],
        [[-0.5, 0], [0.5, 0]]
    ],
    210: [
        [[-0.3, 0.3], [0.3, 0.3]],
        [[-0.5, 1], [0, -1], [0.5, 1]]
    ],
    211: [
        [[-3.5, -0.75], [0.25, -0.75], [3.5, -0.75], [3.5, 0.75], [-0.25, 0.75], [-3.5, 0.75], [-3.5, -0.75]]
    ],
    212: [
        [[-0.5, 0], [0.25, 0], [0.5, 0]],
        [[0, -2.4], [0, 0]],
        [[-1, -2], [-1, -2.4], [-0.9, -2.8], [-0.5, -3], [-0.1, -2.8], [0, -2.4], [0.3, -2.05], [0.7, -2.05], [1, -2.4], [1, -3]]
    ],
    213: [
        [[0, -2.4], [0, 0]],
        [[-1, -2], [-1, -2.4], [-0.9, -2.8], [-0.5, -3], [-0.1, -2.8], [0, -2.4], [0.3, -2.05], [0.7, -2.05], [1, -2.4], [1, -3]]
    ],
    214: [
        [[-1.2, -0.5], [-1.2, -1.5], [-1.05, -1.5], [-1, -1.5], [-0.82, -1.48], [-0.7, -1.25], [-0.84, -1.03], [-1, -1], [-1.15, -1], [-1.2, -1]],
        [[0.75, -0.75], [0.88, -0.53], [1.03, -0.53], [1.12, -0.53], [1.25, -0.75], [1.25, -1.25], [1.12, -1.47], [0.88, -1.46], [0.75, -1.25], [0.75, -0.75]],
        [[-0.5, 0], [0.5, 0]],
        [[0, -2.4], [0, -1.13], [0, 0]],
        [[-1, -2], [-1, -2.4], [-0.9, -2.8], [-0.5, -3], [-0.1, -2.8], [0, -2.4], [0.3, -2.05], [0.7, -2.05], [1, -2.4], [1, -3]]
    ],
    215: [
        [[0.75, -0.75], [0.88, -0.53], [1.03, -0.53], [1.11, -0.53], [1.25, -0.75], [1.25, -1.25], [1.13, -1.47], [0.98, -1.47], [0.89, -1.47], [0.75, -1.25], [0.75, -0.75]],
        [[-1.2, -0.5], [-1.2, -1.5], [-1.05, -1.5], [-1, -1.5], [-0.82, -1.47], [-0.7, -1.25], [-0.82, -1.04], [-1, -1], [-1.15, -1], [-1.2, -1]],
        [[0, -2.4], [0, -1.13], [0, 0]],
        [[-1, -2], [-1, -2.4], [-0.9, -2.8], [-0.5, -3], [-0.1, -2.8], [0, -2.4], [0.3, -2.05], [0.7, -2.05], [1, -2.4], [1, -3]]
    ],
    216: [
        [[-0.7, -1.5], [-0.95, -0.5], [-1.2, -1.5]],
        [[0.75, -1.05], [0.9, -1.05], [1, -1.05], [1.15, -1.25], [1, -1.5], [0.85, -1.5], [0.7, -1.5], [0.7, -0.5], [0.85, -0.5], [1, -0.5], [1.25, -0.65], [1.25, -0.8], [1.25, -0.9], [1, -1.05]],
        [[-1, -2], [-1, -2.4], [-0.88, -2.83], [-0.5, -3], [-0.1, -2.8], [0, -2.4], [0.3, -2.05], [0.7, -2.05], [1, -2.4], [1, -3]],
        [[0, 0], [0, -1.27], [0, -2.4]],
        [[-0.5, 0], [0.5, 0]]
    ],
    217: [
        [[0.7, -1.05], [0.95, -1.05], [1.15, -1.3], [0.95, -1.5], [0.7, -1.5], [0.7, -0.75], [0.7, -0.5], [1, -0.5], [1.25, -0.65], [1.25, -0.9], [0.95, -1.05]],
        [[-1.2, -1.5], [-0.95, -0.5], [-0.7, -1.5]],
        [[0, -2.4], [0, 0]],
        [[-1, -2], [-1, -2.4], [-0.9, -2.8], [-0.5, -3], [-0.1, -2.8], [0, -2.4], [0.3, -2.05], [0.7, -2.05], [1, -2.4], [1, -3]]
    ],
    218: [
        [[0.01, -1.94], [0.01, -0.67], [0, -0.4], [-0.32, -0.24], [-0.38, 0.09], [-0.17, 0.35], [0.18, 0.35], [0.39, 0.09], [0.31, -0.25], [0, -0.4], [-0.2, -0.1], [0.2, -0.1], [0.2, 0.05], [0.2, 0.15], [-0.2, 0.15]],
        [[0, -3.4], [-0.49, -3.22], [-0.74, -2.79], [-0.65, -2.29], [-0.27, -1.94], [0.28, -1.94], [0.66, -2.29], [0.74, -2.81], [0.48, -3.23], [0, -3.4], [0, -2.65], [0.72, -2.65]]
    ],
    219: [
        [[0, -1.55], [0, -0.28], [0, 0]],
        [[0, -3], [-0.48, -2.83], [-0.73, -2.38], [-0.65, -1.88], [-0.25, -1.55], [0.25, -1.55], [0.65, -1.87], [0.74, -2.37], [0.49, -2.82], [0, -3], [0, -2.25], [0.72, -2.26]]
    ],
    220: [
        [[0, -2.9], [1.27, -3.32], [1.5, -3.4], [1.5, -2.13], [1.5, -1.4], [0.23, -1.82], [0, -1.9]],
        [[-0.2, 0.1], [0.25, 0.1], [0.25, -0.05], [0.25, -0.15], [-0.2, -0.15], [0, -0.4], [0.33, -0.25], [0.37, 0.08], [0.2, 0.35], [-0.17, 0.34], [-0.38, 0.08], [-0.29, -0.27], [0, -0.4], [0, -1.67], [0, -2.94], [0, -3.2]]
    ],
    221: [
        [[0, -2.5], [1.5, -3], [1.5, -1.5], [1.5, -1], [0, -1.5]],
        [[0, 0], [0, -1.5], [0, -2.8]]
    ],
    222: [
        [[0, -0.75], [0.49, -0.58], [0.73, -0.14], [0.65, 0.38], [0.28, 0.7], [-0.26, 0.7], [-0.65, 0.38], [-0.74, -0.13], [-0.48, -0.58], [0, -0.75], [0.4, -0.45], [-0.4, -0.45], [-0.55, -0.2], [0.55, -0.2], [0.55, 0.2], [-0.55, 0.2], [-0.35, 0.45], [0.35, 0.45]],
        [[-3.5, 0], [-2.23, 0], [-0.96, 0], [0.31, 0], [1.58, 0], [2.85, 0], [3.5, 0]]
    ],
    223: [
        [[-3.7, 1.5], [3.3, 1.5]],
        [[3.3, -1.5], [-3.7, -1.5]]
    ],
    224: [
        [[3.3, 1.5], [-3.7, 1.5]],
        [[-3.7, 1], [3.3, 1]],
        [[3.3, -1], [-3.7, -1]],
        [[-3.7, -1.5], [3.3, -1.5]]
    ],
    225: [
        [[-0.05, 0], [0.35, 0.75]],
        [[-0.4, 0.75], [-0.4, 0], [-0.4, -0.75], [-0.05, -0.75], [0.2, -0.7], [0.35, -0.4], [0.15, -0.05], [-0.1, 0], [-0.4, 0]],
        [[-1, 1], [1, 1], [1, -1], [-1, -1], [-1, 1]]
    ],
    226: [
        [[-2, -1.5], [-1, -1.5], [0, 0], [1, -1.5], [2, -1.5]]
    ],
    227: [
        [[-2, -1], [-1.25, -1], [-1, -1], [-0.8, -0.4], [-0.3, -0.05], [0.3, -0.05], [0.8, -0.4], [1, -1], [1.75, -1], [2, -1]]
    ],
    228: [
        [[1, -1], [1, -2], [-1, -2], [-1, -1]],
        [[0, 0], [0, -1], [2, -1], [2, 0], [-2, 0], [-2, -1], [0, -1]]
    ],
    229: [
        [[-2, -0.5], [-1, -0.5], [-1, 0.5], [1, 0.5], [1, -0.5], [2, -0.5]]
    ],
    230: [
        [[1.05, -1.05], [1.45, -0.4], [1.45, 0.4], [1.05, 1.06], [0.4, 1.43], [-0.4, 1.45], [-1.05, 1.05], [-1.45, 0.4], [-1.45, -0.4], [-1.05, -1.08], [-0.4, -1.45], [0.4, -1.45], [1.05, -1.05], [-0.22, 0.22], [-1.05, 1.05], [-1.15, 0.7], [-0.8, 0.7], [-0.65, 0.55], [-0.5, 0.4], [-1.3, 0.4], [-1.3, 0.25], [-1.3, 0.1], [-0.2, 0.1], [-0.05, -0.05], [0.1, -0.2], [-1.17, -0.2], [-1.3, -0.2], [-1.25, -0.5], [0.02, -0.5], [0.35, -0.5], [0.5, -0.65], [0.65, -0.8], [-0.62, -0.8], [-1.1, -0.8], [-0.85, -1.1], [0.42, -1.1], [0.75, -1.1]]
    ],
    231: [
        [[-1.5, 1.5], [-1, -1.5], [1, -1.5], [1.5, 1.5], [-1.5, 1.5], [1, -1.5], [0.6, -1.2], [-0.15, -1.2], [-0.9, -1.2], [-1, -0.9], [-0.25, -0.9], [0.35, -0.9], [0.1, -0.6], [-0.65, -0.6], [-1, -0.6], [-1.1, -0.3], [-0.35, -0.3], [-0.15, -0.3], [-0.4, 0], [-1.1, 0], [-1.2, 0.3], [-0.65, 0.3], [-0.9, 0.6], [-1.2, 0.6], [-1.3, 0.9], [-1.15, 0.9], [-1.35, 1.2]]
    ],
    232: [
        [[-2, 1.25], [2, 1.25], [2, -1.25], [-2, -1.25], [-2, 1.25], [2, -1.25], [1.3, -0.95], [-1.85, -0.95], [-1.85, -0.65], [0.75, -0.65], [0.25, -0.35], [-1.85, -0.35], [-1.85, -0.05], [-0.2, -0.05], [-0.65, 0.25], [-1.4, 0.25], [-1.85, 0.25], [-1.85, 0.55], [-1.15, 0.55], [-1.6, 0.85], [-1.85, 0.85]]
    ],
    233: [
        [[0, -1.25], [0.67, -1.06], [1.15, -0.51], [1.24, 0.16], [0.96, 0.8], [0.36, 1.2], [-0.35, 1.2], [-0.94, 0.82], [-1.23, 0.2], [-1.14, -0.51], [-0.69, -1.04], [0, -1.25], [-0.65, -0.9], [0.62, -0.9], [0.65, -0.9], [0.85, -0.6], [-0.42, -0.6], [-0.9, -0.6], [-1, -0.3], [0.27, -0.3], [1, -0.3], [1, 0.3], [-0.27, 0.3], [-1, 0.3], [-0.9, 0.6], [0.37, 0.6], [0.9, 0.6], [0.55, 0.9], [-0.65, 0.9]],
        [[0, -2.25], [0.9, -2.05], [1.7, -1.5], [2.14, -0.69], [2.24, 0.23], [1.95, 1.13], [1.34, 1.81], [0.49, 2.2], [-0.48, 2.19], [-1.3, 1.83], [-1.94, 1.12], [-2.23, 0.22], [-2.13, -0.71], [-1.67, -1.51], [-0.91, -2.06], [0, -2.25]],
        [[0, 3.25], [0, 1.98], [0, 0.71], [0, -0.56], [0, -1.83], [0, -3.1], [0, -3.25]],
        [[-3.25, 0], [-1.98, 0], [-0.71, 0], [0.56, 0], [1.83, 0], [3.1, 0], [3.25, 0]]
    ],
    234: [
        [[0, -1.25], [0.7, -1.05], [1.15, -0.5], [1.24, 0.18], [0.95, 0.8], [0.35, 1.2], [-0.35, 1.2], [-0.93, 0.82], [-1.23, 0.2], [-1.15, -0.5], [-0.68, -1.04], [0, -1.25], [-0.65, -0.9], [0.62, -0.9], [0.65, -0.9], [0.9, -0.6], [-0.37, -0.6], [-0.9, -0.6], [-1, -0.3], [0.27, -0.3], [1, -0.3], [1, 0.3], [-0.27, 0.3], [-1, 0.3], [-0.925, 0.45], [-0.85, 0.6], [0.42, 0.6], [0.85, 0.6], [0.7, 0.75], [0.55, 0.9], [-0.65, 0.9]],
        [[0, -2.25], [0, -0.98], [0, 0.29], [0, 1.56], [0, 2.25]],
        [[-2.25, 0], [-0.98, 0], [0.29, 0], [1.56, 0], [2.25, 0]]
    ],
    235: [
        [[-1.25, 1.25], [1.25, 1.25], [1.25, -1.25], [-1.25, -1.25], [-1.25, 1.25], [-1.1, 0.9], [1.1, 0.9], [1.1, 0.6], [-1.1, 0.6], [-1.1, 0.3], [1.1, 0.3], [1.1, -0.3], [-1.1, -0.3], [-1.1, -0.6], [1.1, -0.6], [1.1, -0.9], [-1.1, -0.9]],
        [[0, -2.25], [0, 2.25]],
        [[-2.25, 0], [2.25, 0]]
    ],
    236: [
        [[0.1, -1], [0.475, -0.25], [0.6, 0]],
        [[-0.4, 0], [-0.4, -2], [0.1, -2], [0.5, -1.8], [0.6, -1.4], [0.3, -1.05], [0.1, -1], [-0.4, -1]]
    ],
    237: [
        [[-0.05, 2.25], [0.18, 2.21], [0.4, 1.93], [0.31, 1.6], [-0.17, 1.45], [-0.38, 1.19], [-0.29, 0.84], [0.01, 0.7], [0.26, 0.69], [0.66, 0.37], [0.74, -0.15], [0.49, -0.58], [0, -0.75], [-0.47, -0.59], [-0.73, -0.14], [-0.65, 0.37], [-0.25, 0.7], [-0.1, 0.7], [0, 0.7]]
    ],
    238: [
        [[1, -0.5], [3, 0], [1, 0.5]],
        [[-3, 0], [3, 0]]
    ],
    239: [
        [[1.5, 0], [7.5, 0]],
        [[-7.5, 0], [-1.5, 0]]
    ],
    240: [
        [[-1.5, 0], [1.5, 0]]
    ],
    241: [
        [[1.5, 0], [-1.5, 0]],
        [[0.5, -1], [1.5, -1]],
        [[-1.5, -1], [-0.5, -1]]
    ],
    242: [
        [[-1.5, 0], [1.5, 0]],
        [[1.5, -1], [-1.5, -1]]
    ],
    243: [
        [[-2, -0.5], [-3, 0], [-2, 0.5]],
        [[-1, 0], [-3, 0]],
        [[3, 0], [1, 0]]
    ],
    244: [
        [[0, -1], [0, 1]]
    ],
    245: [
        [[0.5, -2], [-0.5, -2], [0, 0]]
    ],
    246: [
        [[-0.5, -2], [0.25, -2], [0.5, -2], [0, 0], [-0.5, -2], [-0.3, -1.7], [0.3, -1.7], [0.25, -1.4], [-0.2, -1.4], [-0.1, -1.1], [0.15, -1.1], [0.05, -0.7]]
    ],
    247: [
        [[0.75, 0], [0.58, 0.48], [0.13, 0.74], [-0.38, 0.64], [-0.7, 0.25], [-0.7, -0.26], [-0.37, -0.65], [0.13, -0.74], [0.58, -0.48], [0.75, 0], [-0.52, 0], [-0.7, 0]]
    ],
    248: [
        [[0.75, 0], [0.59, 0.47], [0.15, 0.73], [-0.38, 0.65], [-0.7, 0.27], [-0.7, -0.26], [-0.38, -0.65], [0.13, -0.74], [0.57, -0.49], [0.75, 0], [-0.52, 0], [-0.7, 0]],
        [[1.15, -0.5], [1.24, 0.18], [0.95, 0.81], [0.35, 1.2], [-0.34, 1.2], [-0.94, 0.82], [-1.23, 0.19], [-1.14, -0.52], [-0.68, -1.05], [0, -1.25], [0.7, -1.05], [1.15, -0.5]]
    ],
    249: [
        [[2, -1.4], [2, -1.5]],
        [[1.7, 0.35], [1.95, 0.2], [2, -0.05], [2, -0.8], [2, -1]],
        [[1.3, -1.5], [1.3, -0.75], [1.3, 0]],
        [[1.3, -0.35], [1.1, 0], [0.8, 0], [0.6, -0.3], [0.6, -0.7], [0.8, -1], [1.1, -1], [1.3, -0.7]],
        [[-0.35, -1], [0, 0], [0.35, -1]]
    ],
    250: [
        [[0, -0.9], [-0.9, -2.5], [0.9, -2.5], [0, -0.9], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [-0.3, -0.2], [0.3, -0.2], [0.35, 0.1], [-0.3, 0.1], [-0.15, 0.35], [0.15, 0.35]]
    ],
    251: [
        [[0, -1], [0, 0]],
        [[1, 1], [-1, -1]],
        [[-1, 1], [1, -1]]
    ],
    252: [
        [[-1.5, -0.45], [-1.75, -1], [-1.2, -1.05]],
        [[1.2, -1.05], [1.75, -1], [1.45, -0.45]],
        [[-1.75, -1], [-0.95, -0.65], [0, -0.5], [0.9, -0.65], [1.75, -1]],
        [[-0.12, -4.47], [0.14, -4.46], [0.24, -4.27], [0.12, -4.04], [-0.03, -4.04], [-0.11, -4.04], [-0.24, -4.24], [-0.13, -4.49], [0.18, -4.27], [-0.15, -4.24], [0, -4], [0, -2.73], [0, -1.46], [0, -0.19], [0, 0]],
        [[-0.5, -4], [0.5, -4]]
    ],
    253: [
        [[-0.5, -1.3], [-0.4, -1.45], [-0.2, -1.45], [0, -1.25], [0.2, -1.45], [0.4, -1.45], [0.5, -1.3]],
        [[0, -1.9], [0, 0]],
        [[-1, -2.1], [-0.8, -2.4], [-0.5, -2.5], [-0.15, -2.35], [0, -1.9], [0.15, -2.35], [0.5, -2.5], [0.8, -2.4], [1, -2.1]]
    ],
    254: [
        [[-0.05, 0], [0.05, 0]],
        [[-0.5, -1.85], [-0.4, -1.95], [-0.2, -1.95], [0, -1.75], [0.2, -1.95], [0.4, -1.95], [0.5, -1.8]],
        [[-1, -2.6], [-0.8, -2.9], [-0.5, -3], [-0.15, -2.9], [0, -2.4], [0.15, -2.9], [0.5, -3], [0.8, -2.9], [1, -2.6]],
        [[0, -0.5], [0.4, -0.3], [0.5, 0.1], [0.2, 0.45], [-0.2, 0.45], [-0.5, 0.1], [-0.4, -0.3], [0, -0.5], [0, -2.4]]
    ],
    255: [
        [[-7.5, 0], [-1.5, 0]],
        [[-8.5, -1], [-8.2, -0.95], [-7.7, -0.6], [-7.5, 0], [-7.7, 0.6], [-8.2, 0.95], [-8.5, 1]],
        [[7.5, 0], [1.5, 0]],
        [[8.5, -1], [8.2, -0.95], [7.7, -0.6], [7.5, 0], [7.7, 0.6], [8.2, 0.95], [8.5, 1]]
    ],
    256: [
        [[-2.25, 0], [-0.98, 0], [0.29, 0], [1.56, 0], [2.25, 0]],
        [[0, 2.25], [0, 0.98], [0, -0.29], [0, -1.56], [0, -2.25]],
        [[0, -1.25], [-0.69, -1.04], [-1.14, -0.52], [-1.23, 0.2], [-0.94, 0.82], [-0.35, 1.2], [0.35, 1.2], [0.94, 0.82], [1.24, 0.18], [1.15, -0.5], [0.69, -1.04], [0, -1.25], [0.65, -0.9], [0.15, -0.9], [0.15, -0.75], [0.15, -0.6], [0.9, -0.6], [1, -0.3], [0.15, -0.3], [-0.15, 0.3], [-1, 0.3], [-0.9, 0.6], [-0.15, 0.6], [-0.15, 0.75], [-0.15, 0.9], [-0.65, 0.9]]
    ],
    257: [
        [[-1.5, 0], [-1.31, -0.73], [-0.77, -1.29], [0, -1.5], [0.75, -1.3], [1.29, -0.77], [1.5, 0], [1.3, -0.3], [0.15, -0.3], [0.15, -0.45], [0.15, -0.6], [1.2, -0.6], [1, -0.9], [0.15, -0.9], [0.15, -1.05], [0.15, -1.2], [0.7, -1.2]],
        [[0, -2.5], [0, -1.23], [0, 0]],
        [[-2.5, 0], [-1.23, 0], [0.04, 0], [1.31, 0], [2.5, 0]]
    ],
    258: [
        [[-1.5, 0], [-0.75, 0], [-0.75, -0.6], [-0.65, -1.13], [-0.26, -1.45], [0.26, -1.45], [0.65, -1.12], [0.75, -0.6], [0.75, 0], [1.5, 0]]
    ],
    259: [
        [[-1.5, 0], [-0.75, -1.5], [0, 0], [1.5, -3], [3, 0]]
    ],
    260: [
        [[-1, -5], [-1, -3.73], [-1, -2.5], [-0.16, -3.77], [0, -4], [0, -2.73], [0, -1.46], [0, -0.5], [-0.4, -0.29], [-0.49, 0.1], [-0.22, 0.45], [0.22, 0.45], [0.49, 0.1], [0.4, -0.29], [0, -0.5], [-0.5, -1.4]],
        [[0.5, -1.4], [0, -0.5]],
        [[-0.05, 0], [0.05, 0]]
    ],
    261: [
        [[-1, 1], [-1, -0.5], [-1, -1], [0.5, -1], [1, -1], [1, 0.5], [1, 1], [-0.5, 1], [-1, 1]],
        [[-0.5, 0.7], [0, -0.7], [0.5, 0.7]],
        [[0.3, 0.2], [-0.3, 0.2]]
    ],
    262: [
        [[5, -0.35], [3.73, -0.35], [2.46, -0.35], [2, -0.35], [2, 0.35], [3.27, 0.35], [4.54, 0.35], [5, 0.35], [5, -0.35]],
        [[4.8, -0.15], [3.53, -0.15], [2.26, -0.15], [2.2, -0.15], [2.2, 0], [2.2, 0.15], [3.47, 0.15], [4.74, 0.15], [4.8, 0.15], [4.8, 0], [4.8, -0.15]],
        [[0, -0.35], [-1.27, -0.35], [-2.54, -0.35], [-3, -0.35], [-3, 0.35], [-1.73, 0.35], [-0.46, 0.35], [0, 0.35], [0, -0.35]],
        [[-0.2, -0.15], [-1.47, -0.15], [-2.74, -0.15], [-2.8, -0.15], [-2.8, 0], [-2.8, 0.15], [-1.53, 0.15], [-0.26, 0.15], [-0.2, 0.15], [-0.2, 0], [-0.2, -0.15]],
        [[-4.62, -0.3], [-4.8, 0], [-4.62, 0.3], [-4.27, 0.3], [-4.1, 0], [-4.27, -0.3], [-4.62, -0.3]],
        [[-4.1, 0], [-4.27, -0.3], [-4.62, -0.3], [-4.8, 0], [-4.62, 0.3], [-4.28, 0.3], [-4.1, 0], [-4.5, 0.2], [-4.6, -0.2]]
    ],
    263: [
        [[0, -0.5], [-0.39, -0.31], [-0.49, 0.11], [-0.22, 0.45], [0.22, 0.45], [0.49, 0.11], [0.39, -0.31], [0, -0.5]],
        [[5, -1], [5, 0.27], [5, 1]],
        [[1.5, 1], [1.5, -0.27], [1.5, -1]],
        [[-1.5, -1], [-1.5, 0.27], [-1.5, 1]],
        [[-5, 1], [-5, -0.27], [-5, -1]],
        [[-4.9, -0.5], [-3.63, -0.5], [-2.36, -0.5], [-1.6, -0.5], [-1.6, 0.5], [-2.87, 0.5], [-4.14, 0.5], [-4.9, 0.5], [-4.9, -0.5], [-4.65, 0.25], [-3.38, 0.25], [-2.11, 0.25], [-1.85, 0.25], [-1.85, 0.1], [-1.85, 0], [-3.12, 0], [-4.39, 0], [-4.6, 0], [-4.6, -0.15], [-4.6, -0.25], [-3.33, -0.25], [-2.06, -0.25], [-1.85, -0.25]],
        [[0, -0.5], [-0.39, -0.32], [-0.48, 0.09], [-0.2, 0.45], [0.21, 0.45], [0.49, 0.11], [0.4, -0.32], [0, -0.5], [-0.3, -0.15], [0.3, -0.15], [0.3, 0.2], [-0.25, 0.2]],
        [[1.6, 0.5], [2.87, 0.5], [4.14, 0.5], [4.9, 0.5], [4.9, -0.5], [3.63, -0.5], [2.36, -0.5], [1.6, -0.5], [1.6, 0.5], [1.85, -0.25], [3.12, -0.25], [4.39, -0.25], [4.65, -0.25], [4.65, -0.1], [4.65, 0], [3.38, 0], [2.11, 0], [1.9, 0], [1.9, 0.15], [1.9, 0.25], [3.17, 0.25], [4.44, 0.25], [4.65, 0.25]]
    ],
    264: [
        [[-4.4, -0.5], [-1.1, -0.5], [-1.1, 0.25], [-1.1, 0.5], [-4.4, 0.5], [-4.4, -0.25], [-4.4, -0.5], [-4.15, 0.25], [-1.35, 0.25], [-1.35, 0], [-4.1, 0], [-4.1, -0.25], [-1.35, -0.25]],
        [[-4.5, 1], [-4.5, -1]],
        [[-1, -1], [-1, 1]],
        [[4.5, -1], [4.5, 1]],
        [[1, 1], [1, -1]],
        [[1.1, 0.5], [4.4, 0.5], [4.4, -0.25], [4.4, -0.5], [1.1, -0.5], [1.1, 0.25], [1.1, 0.5], [1.35, -0.25], [4.15, -0.25], [4.15, 0], [1.4, 0], [1.4, 0.25], [4.15, 0.25]]
    ],
    493: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [-0.4, -0.3], [-0.47, 0.11], [-0.22, 0.45], [0.22, 0.45], [0.49, 0.11], [0.4, -0.3], [0, -0.5]],
        [[0.45, 0], [1.5, 0]],
        [[-1.5, 0], [-0.45, 0]],
        [[0, 0.45], [0, 1.45]]
    ],
    494: [
        [[-1.5, 0], [-0.45, 0]],
        [[0.45, 0], [1.5, 0]],
        [[0, -0.5], [-0.4, -0.3], [-0.47, 0.11], [-0.22, 0.45], [0.22, 0.45], [0.49, 0.11], [0.4, -0.3], [0, -0.5]],
        [[-0.05, 0], [0.05, 0]]
    ],
    495: [
        [[-1.1, 0.95], [-0.35, 0.3]],
        [[0.35, -0.35], [1.15, -1.05]],
        [[-1.25, -1.05], [-0.35, -0.35]],
        [[0.4, 0.25], [1.25, 0.95]],
        [[0, -0.5], [-0.4, -0.3], [-0.48, 0.1], [-0.22, 0.45], [0.21, 0.45], [0.49, 0.1], [0.39, -0.31], [0, -0.5]],
        [[-0.05, 0], [0.05, 0]]
    ],
    496: [
        [[0, 1.75], [0, 0.75], [0.5, 0.6], [0.75, 0.15], [0.68, -0.35], [0.3, -0.7], [-0.2, -0.7], [-0.62, -0.36], [-0.72, 0.13], [-0.48, 0.57], [0, 0.75]],
        [[-0.05, 0], [0.05, 0]]
    ],
    497: [
        [[-1.25, 0.5], [1.25, 0.5], [1.25, -0.25], [1.25, -0.5], [-1.25, -0.5], [-1.25, 0.25], [-1.25, 0.5], [1.25, -0.5], [1.1, -0.1], [0.5, -0.1], [-0.25, 0.2], [0.5, 0.2], [1.1, 0.2], [1.1, 0.4]]
    ],
    498: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [0, -4.5], [3.9, -5.4]],
        [[2.9, -5.15], [3.15, -4.15], [1.2, -3.7], [0.95, -4.7]]
    ],
    500: [
        [[0, -2.5], [-1, -1.5], [-1, -4.5], [-1.5, -3.5]],
        [[-0.5, -3.5], [-1, -4.5]]
    ],
    502: [
        [[0, -4.5], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5]]
    ],
    503: [
        [[0, -4.5], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5]],
        [[-0.45, 0], [0.3, 0], [0.45, 0], [-0.25, 0.25], [0.25, 0.25]]
    ],
    504: [
        [[0, -4.5], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [-0.3, -0.1], [0.3, -0.1], [0.3, 0.2], [-0.3, 0.2]]
    ],
    505: [
        [[0.7, -4.3], [1.97, -5.18], [2.35, -5.45]],
        [[1.95, -5.17], [2.04, -4.78], [1.81, -4.38], [1.35, -4.35], [1.05, -4.55]],
        [[1.5, -4.9], [1.25, -5.3], [0.75, -5.5], [0.25, -5.3], [0, -4.9], [0, -3.63], [0, -2.36], [0, -1.09], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5]],
        [[-0.05, 0], [0.05, 0]]
    ],
    506: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [0, -4.5], [3.9, -5.4]],
        [[2.9, -5.15], [3.15, -4.15], [1.2, -3.7], [0.95, -4.7]]
    ],
    507: [
        [[-1, -5], [0.27, -5], [1, -5]],
        [[0.48, -5.01], [0.41, -4.71], [0, -4.5], [-0.4, -4.7], [-0.47, -5.01]],
        [[0, -4.5], [0, -3.23], [0, -1.96], [0, -0.69], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.21, 0.44], [0.22, 0.44], [0.5, 0.1], [0.4, -0.3], [0, -0.5]],
        [[-0.05, 0], [0.05, 0]]
    ],
    508: [
        [[-0.05, 0], [0.05, 0]],
        [[0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [0, -3.5], [0.6, -3.7], [0.95, -4.2], [0.95, -4.8], [0.6, -5.3], [0, -5.5], [-0.6, -5.3], [-0.95, -4.8], [-0.95, -4.2], [-0.6, -3.7], [0, -3.5]]
    ],
    509: [
        [[0, 0.76], [0.15, 0.76], [0.18, 0.76], [0.39, 0.49], [0.32, 0.15], [0, 0]]
    ],
    510: [
        [[0, -0.76], [-0.15, -0.76], [-0.18, -0.76], [-0.39, -0.49], [-0.32, -0.15], [0, 0]]
    ],
    511: [
        [[-1, -0.5], [-1, 0.25], [-1, 0.5], [-0.25, 0.125], [0, 0], [-0.75, -0.375], [-1, -0.5], [-0.85, -0.2], [-0.55, -0.2], [-0.2, 0], [-0.85, 0], [-0.85, 0.2], [-0.55, 0.2]]
    ],
    512: [
        [[-0.3, -0.95], [0.3, -0.95], [0.81, -0.59], [1, 0], [0.81, 0.59], [0.3, 0.95], [-0.3, 0.95], [-0.8, 0.6], [-1, 0], [-0.8, -0.6], [-0.3, -0.95], [0.3, -0.8], [0.7, -0.5], [0.85, 0], [0.7, 0.5], [0.3, 0.8], [-0.3, 0.8], [-0.7, 0.5], [-0.85, 0], [-0.65, -0.6], [-0.3, -0.8], [0, -0.75], [0.48, -0.57], [0.74, -0.13], [0.65, 0.37], [0.26, 0.7], [-0.26, 0.7], [-0.65, 0.4], [-0.74, -0.13], [-0.48, -0.57], [0, -0.75]]
    ],
    513: [
        [[0, -0.75], [0.48, -0.57], [0.74, -0.13], [0.65, 0.37], [0.26, 0.7], [-0.26, 0.7], [-0.65, 0.37], [-0.74, -0.13], [-0.48, -0.57], [0, -0.75]]
    ],
    514: [
        [[-0.25, 0], [-0.12, -0.22], [0.03, -0.22], [0.13, -0.22], [0.25, 0], [0.13, 0.22], [-0.02, 0.22], [-0.12, 0.22], [-0.25, 0]]
    ],
    515: [
        [[0, -1.27], [0, -2.54], [0, -3.81], [0, -5]],
        [[0.4, -3.95], [-0.4, -3.95], [-1.06, -3.56], [-1.45, -2.9], [-1.45, -2.1], [-1.06, -1.44], [-0.4, -1.05], [0.4, -1.05], [1.06, -1.44], [1.45, -2.1], [1.45, -2.9], [1.06, -3.56], [0.4, -3.95], [0.55, -3.8], [0.65, -3.7], [0.15, -3.7], [0.15, -3.55], [0.15, -3.4], [1, -3.4], [1.075, -3.25], [1.15, -3.1], [0.15, -3.1], [0.15, -2.95], [0.15, -2.8], [1.3, -2.8], [1.3, -2.65], [1.3, -2.5], [0.15, -2.5], [0.15, -2.35], [0.15, -2.2], [1.3, -2.2], [1.225, -2.05], [1.15, -1.9], [0.15, -1.9], [0.15, -1.75], [0.15, -1.6], [1, -1.6], [0.6, -1.3], [0.15, -1.3]]
    ],
    516: [
        [[0, -1.27], [0, -2.54], [0, -3.81], [0, -5]],
        [[-0.4, -3.95], [0.4, -3.95], [1.08, -3.54], [1.45, -2.89], [1.45, -2.11], [1.06, -1.44], [0.4, -1.05], [-0.4, -1.05], [-1.06, -1.44], [-1.45, -2.1], [-1.45, -2.9], [-1.06, -3.56], [-0.4, -3.95], [-0.55, -3.8], [-0.65, -3.7], [-0.15, -3.7], [-0.15, -3.55], [-0.15, -3.4], [-1, -3.4], [-1.2, -3.1], [-0.15, -3.1], [-0.15, -2.95], [-0.15, -2.8], [-1.3, -2.8], [-1.3, -2.65], [-1.3, -2.5], [-0.15, -2.5], [-0.15, -2.35], [-0.15, -2.2], [-1.3, -2.2], [-1.225, -2.05], [-1.15, -1.9], [-0.15, -1.9], [-0.15, -1.75], [-0.15, -1.6], [-1, -1.6], [-0.65, -1.3], [-0.15, -1.3]]
    ],
    517: [
        [[0, 1.27], [0, 2.54], [0, 3.81], [0, 5]],
        [[0.4, 3.95], [-0.4, 3.95], [-1.08, 3.54], [-1.45, 2.9], [-1.45, 2.1], [-1.06, 1.44], [-0.4, 1.05], [0.4, 1.05], [1.06, 1.44], [1.45, 2.11], [1.45, 2.89], [1.06, 3.56], [0.4, 3.95], [0.55, 3.8], [0.65, 3.7], [0.15, 3.7], [0.15, 3.55], [0.15, 3.4], [1, 3.4], [1.075, 3.25], [1.15, 3.1], [0.15, 3.1], [0.15, 2.95], [0.15, 2.8], [1.3, 2.8], [1.3, 2.65], [1.3, 2.5], [0.15, 2.5], [0.15, 2.35], [0.15, 2.2], [1.3, 2.2], [1.225, 2.05], [1.15, 1.9], [0.15, 1.9], [0.15, 1.75], [0.15, 1.6], [0.95, 1.6], [0.6, 1.3], [0.15, 1.3]]
    ],
    518: [
        [[0, 1.27], [0, 2.54], [0, 3.81], [0, 5]],
        [[-0.4, 3.95], [0.4, 3.95], [1.06, 3.56], [1.45, 2.9], [1.45, 2.1], [1.06, 1.44], [0.36, 1.04], [-0.39, 1.05], [-1.06, 1.44], [-1.45, 2.1], [-1.45, 2.9], [-1.06, 3.56], [-0.4, 3.95], [-0.55, 3.8], [-0.65, 3.7], [-0.15, 3.7], [-0.15, 3.55], [-0.15, 3.4], [-1, 3.4], [-1.2, 3.1], [-0.15, 3.1], [-0.15, 2.95], [-0.15, 2.8], [-1.3, 2.8], [-1.3, 2.65], [-1.3, 2.5], [-0.15, 2.5], [-0.15, 2.35], [-0.15, 2.2], [-1.3, 2.2], [-1.225, 2.05], [-1.15, 1.9], [-0.15, 1.9], [-0.15, 1.75], [-0.15, 1.6], [-1, 1.6], [-0.6, 1.3], [-0.15, 1.3]]
    ],
    519: [
        [[0, -0.5], [0, 0.5]]
    ],
    520: [
        [[3.55, -3.55], [2.28, -2.28], [1.01, -1.01], [0, 0], [-1.27, -1.27], [-2.54, -2.54], [-3.55, -3.55]],
        [[-2.86, -2.86], [-3.25, -2.19], [-3.25, -1.41], [-2.83, -0.71], [-2.19, -0.35], [-1.41, -0.35], [-0.74, -0.74], [-0.35, -1.41], [-0.35, -2.19], [-0.71, -2.83], [-1.41, -3.25], [-2.19, -3.25], [-2.86, -2.86], [-2.5, -2.75], [-2.15, -3.1], [-1.7, -3.1], [-2.25, -2.55], [-2.1, -2.4], [-2.05, -2.35], [-1.35, -3.05], [-1.2, -2.975], [-1.05, -2.9], [-1.85, -2.1], [-1.6, -1.9], [-0.85, -2.7], [-0.65, -2.45], [-1.4, -1.7], [-1.25, -1.55], [-1.2, -1.5], [-0.5, -2.2], [-0.5, -1.75], [-1, -1.25], [-0.85, -1.1], [-0.8, -1.05], [-0.65, -1.2], [-0.5, -1.35]],
        [[0.74, -0.74], [1.41, -0.35], [2.19, -0.35], [2.86, -0.74], [3.25, -1.41], [3.25, -2.19], [2.86, -2.86], [2.19, -3.25], [1.41, -3.25], [0.74, -2.86], [0.35, -2.19], [0.35, -1.41], [0.74, -0.74], [0.9, -1.1], [0.45, -1.55], [0.45, -1.95], [1.05, -1.35], [1.3, -1.55], [0.55, -2.25], [0.625, -2.4], [0.7, -2.55], [1.5, -1.75], [1.65, -1.9], [1.7, -1.95], [0.9, -2.8], [1.15, -2.95], [1.95, -2.15], [2.1, -2.3], [2.15, -2.35], [1.45, -3.05], [1.85, -3.1], [2.35, -2.6], [2.6, -2.8], [2.45, -2.95], [2.35, -3.05]]
    ],
    521: [
        [[0.69, -0.74], [1.36, -0.35], [2.14, -0.35], [2.81, -0.74], [3.2, -1.41], [3.2, -2.19], [2.81, -2.86], [2.14, -3.25], [1.36, -3.25], [0.69, -2.86], [0.3, -2.19], [0.3, -1.41], [0.69, -0.74], [0.85, -1.1], [0.4, -1.55], [0.4, -1.95], [1, -1.35], [1.25, -1.55], [0.5, -2.25], [0.575, -2.4], [0.65, -2.55], [1.45, -1.75], [1.6, -1.9], [1.65, -1.95], [0.85, -2.8], [1.1, -2.95], [1.9, -2.15], [2.05, -2.3], [2.1, -2.35], [1.4, -3.05], [1.8, -3.1], [2.3, -2.6], [2.55, -2.8], [2.4, -2.95], [2.3, -3.05]],
        [[-2.85, -2.81], [-2.19, -3.21], [-1.41, -3.23], [-0.7, -2.83], [-0.33, -2.2], [-0.31, -1.42], [-0.68, -0.74], [-1.35, -0.34], [-2.12, -0.32], [-2.77, -0.66], [-3.21, -1.35], [-3.23, -2.13], [-2.85, -2.81], [-2.73, -2.45], [-3.08, -2.09], [-3.07, -1.64], [-2.53, -2.21], [-2.32, -2.01], [-3.01, -1.3], [-2.85, -1], [-2.07, -1.82], [-1.86, -1.57], [-2.65, -0.8], [-2.39, -0.61], [-1.66, -1.38], [-1.51, -1.23], [-1.46, -1.18], [-2.14, -0.47], [-1.69, -0.48], [-1.2, -0.99], [-1.05, -0.84], [-1, -0.79], [-1.29, -0.49]],
        [[-3.5, -3.55], [-2.25, -2.28], [-1, -1.01], [0, 0], [1.27, -1.27], [2.54, -2.54], [3.55, -3.55]]
    ],
    522: [
        [[-2.86, -2.86], [-3.25, -2.19], [-3.25, -1.41], [-2.83, -0.71], [-2.19, -0.35], [-1.41, -0.35], [-0.74, -0.74], [-0.35, -1.41], [-0.35, -2.19], [-0.71, -2.83], [-1.41, -3.25], [-2.19, -3.25], [-2.86, -2.86], [-2.5, -2.75], [-2.15, -3.1], [-1.7, -3.1], [-2.25, -2.55], [-2.1, -2.4], [-2.05, -2.35], [-1.35, -3.05], [-1.2, -2.975], [-1.05, -2.9], [-1.85, -2.1], [-1.6, -1.9], [-0.85, -2.7], [-0.65, -2.45], [-1.4, -1.7], [-1.25, -1.55], [-1.2, -1.5], [-0.5, -2.2], [-0.5, -1.75], [-1, -1.25], [-0.85, -1.1], [-0.8, -1.05], [-0.65, -1.2], [-0.5, -1.35]],
        [[2.86, -2.81], [2.19, -3.2], [1.41, -3.2], [0.71, -2.78], [0.35, -2.14], [0.35, -1.36], [0.74, -0.69], [1.41, -0.3], [2.19, -0.3], [2.83, -0.66], [3.25, -1.36], [3.25, -2.14], [2.86, -2.81], [2.75, -2.45], [3.1, -2.1], [3.1, -1.65], [2.55, -2.2], [2.4, -2.05], [2.35, -2], [3.05, -1.3], [2.975, -1.15], [2.9, -1], [2.1, -1.8], [1.9, -1.55], [2.7, -0.8], [2.45, -0.6], [1.7, -1.35], [1.55, -1.2], [1.5, -1.15], [2.2, -0.45], [1.75, -0.45], [1.25, -0.95], [1.1, -0.8], [1.05, -0.75], [1.2, -0.6], [1.35, -0.45]],
        [[3.55, -3.55], [2.28, -2.28], [1.01, -1.01], [0, 0], [-1.27, -1.27], [-2.54, -2.54], [-3.55, -3.55]]
    ],
    523: [
        [[2.81, -2.81], [2.14, -3.2], [1.36, -3.2], [0.66, -2.78], [0.3, -2.14], [0.3, -1.36], [0.69, -0.69], [1.36, -0.3], [2.14, -0.3], [2.78, -0.66], [3.2, -1.36], [3.2, -2.14], [2.81, -2.81], [2.7, -2.45], [3.05, -2.1], [3.05, -1.65], [2.5, -2.2], [2.35, -2.05], [2.3, -2], [3, -1.3], [2.925, -1.15], [2.85, -1], [2.05, -1.8], [1.85, -1.55], [2.65, -0.8], [2.4, -0.6], [1.65, -1.35], [1.5, -1.2], [1.45, -1.15], [2.15, -0.45], [1.7, -0.45], [1.2, -0.95], [1.05, -0.8], [1, -0.75], [1.15, -0.6], [1.3, -0.45]],
        [[-0.69, -0.69], [-0.3, -1.36], [-0.3, -2.14], [-0.69, -2.81], [-1.36, -3.2], [-2.14, -3.2], [-2.81, -2.81], [-3.2, -2.14], [-3.2, -1.36], [-2.81, -0.69], [-2.14, -0.3], [-1.36, -0.3], [-0.69, -0.69], [-1.05, -0.85], [-1.5, -0.4], [-1.9, -0.4], [-1.3, -1], [-1.5, -1.25], [-2.2, -0.5], [-2.35, -0.575], [-2.5, -0.65], [-1.7, -1.45], [-1.85, -1.6], [-1.9, -1.65], [-2.75, -0.85], [-2.9, -1.1], [-2.1, -1.9], [-2.25, -2.05], [-2.3, -2.1], [-3, -1.4], [-3.05, -1.8], [-2.55, -2.3], [-2.75, -2.55], [-2.9, -2.4], [-3, -2.3]],
        [[-3.55, -3.55], [-2.28, -2.28], [-1.01, -1.01], [0, 0], [1.27, -1.27], [2.54, -2.54], [3.55, -3.55]]
    ],
    524: [
        [[0.4, -3.95], [-0.4, -3.95], [-1.06, -3.56], [-1.45, -2.9], [-1.45, -2.1], [-1.06, -1.44], [-0.4, -1.05], [0.4, -1.05], [1.06, -1.44], [1.45, -2.1], [1.45, -2.9], [1.06, -3.56], [0.4, -3.95], [0.55, -3.8], [0.65, -3.7], [0.15, -3.7], [0.15, -3.55], [0.15, -3.4], [1, -3.4], [1.075, -3.25], [1.15, -3.1], [0.15, -3.1], [0.15, -2.95], [0.15, -2.8], [1.3, -2.8], [1.3, -2.65], [1.3, -2.5], [0.15, -2.5], [0.15, -2.35], [0.15, -2.2], [1.3, -2.2], [1.225, -2.05], [1.15, -1.9], [0.15, -1.9], [0.15, -1.75], [0.15, -1.6], [1, -1.6], [0.6, -1.3], [0.15, -1.3]],
        [[-0.4, 3.95], [0.4, 3.95], [1.06, 3.56], [1.45, 2.9], [1.45, 2.1], [1.06, 1.44], [0.4, 1.05], [-0.4, 1.05], [-1.06, 1.44], [-1.45, 2.1], [-1.45, 2.9], [-1.06, 3.56], [-0.4, 3.95], [-0.55, 3.8], [-0.65, 3.7], [-0.15, 3.7], [-0.15, 3.55], [-0.15, 3.4], [-1, 3.4], [-1.075, 3.25], [-1.15, 3.1], [-0.15, 3.1], [-0.15, 2.95], [-0.15, 2.8], [-1.3, 2.8], [-1.3, 2.65], [-1.3, 2.5], [-0.15, 2.5], [-0.15, 2.35], [-0.15, 2.2], [-1.3, 2.2], [-1.225, 2.05], [-1.15, 1.9], [-0.15, 1.9], [-0.15, 1.75], [-0.15, 1.6], [-1, 1.6], [-0.6, 1.3], [-0.15, 1.3]],
        [[0, 5], [0, 3.73], [0, 2.46], [0, 1.19], [0, -0.08], [0, -1.35], [0, -2.62], [0, -3.89], [0, -5]]
    ],
    525: [
        [[-0.4, -3.95], [0.4, -3.95], [1.08, -3.54], [1.45, -2.89], [1.45, -2.11], [1.06, -1.44], [0.4, -1.05], [-0.4, -1.05], [-1.06, -1.44], [-1.45, -2.1], [-1.45, -2.9], [-1.06, -3.56], [-0.4, -3.95], [-0.55, -3.8], [-0.65, -3.7], [-0.15, -3.7], [-0.15, -3.55], [-0.15, -3.4], [-1, -3.4], [-1.2, -3.1], [-0.15, -3.1], [-0.15, -2.95], [-0.15, -2.8], [-1.3, -2.8], [-1.3, -2.65], [-1.3, -2.5], [-0.15, -2.5], [-0.15, -2.35], [-0.15, -2.2], [-1.3, -2.2], [-1.225, -2.05], [-1.15, -1.9], [-0.15, -1.9], [-0.15, -1.75], [-0.15, -1.6], [-1, -1.6], [-0.65, -1.3], [-0.15, -1.3]],
        [[0.4, 3.95], [-0.4, 3.95], [-1.08, 3.54], [-1.45, 2.89], [-1.45, 2.11], [-1.06, 1.44], [-0.4, 1.05], [0.4, 1.05], [1.06, 1.44], [1.45, 2.1], [1.45, 2.9], [1.06, 3.56], [0.4, 3.95], [0.55, 3.8], [0.65, 3.7], [0.15, 3.7], [0.15, 3.55], [0.15, 3.4], [1, 3.4], [1.2, 3.1], [0.15, 3.1], [0.15, 2.95], [0.15, 2.8], [1.3, 2.8], [1.3, 2.65], [1.3, 2.5], [0.15, 2.5], [0.15, 2.35], [0.15, 2.2], [1.3, 2.2], [1.225, 2.05], [1.15, 1.9], [0.15, 1.9], [0.15, 1.75], [0.15, 1.6], [1, 1.6], [0.65, 1.3], [0.15, 1.3]],
        [[0, 5], [0, 3.73], [0, 2.46], [0, 1.19], [0, -0.08], [0, -1.35], [0, -2.62], [0, -3.89], [0, -5]]
    ],
    526: [
        [[0.4, -1.05], [-0.4, -1.05], [-1.08, -1.46], [-1.45, -2.11], [-1.45, -2.89], [-1.06, -3.56], [-0.4, -3.95], [0.4, -3.95], [1.06, -3.56], [1.45, -2.9], [1.45, -2.1], [1.06, -1.44], [0.4, -1.05], [0.55, -1.2], [0.65, -1.3], [0.15, -1.3], [0.15, -1.45], [0.15, -1.6], [1, -1.6], [1.2, -1.9], [0.15, -1.9], [0.15, -2.05], [0.15, -2.2], [1.3, -2.2], [1.3, -2.35], [1.3, -2.5], [0.15, -2.5], [0.15, -2.65], [0.15, -2.8], [1.3, -2.8], [1.225, -2.95], [1.15, -3.1], [0.15, -3.1], [0.15, -3.25], [0.15, -3.4], [1, -3.4], [0.65, -3.7], [0.15, -3.7]],
        [[0.4, 3.95], [-0.4, 3.95], [-1.08, 3.54], [-1.45, 2.89], [-1.45, 2.11], [-1.06, 1.44], [-0.4, 1.05], [0.4, 1.05], [1.06, 1.44], [1.45, 2.1], [1.45, 2.9], [1.06, 3.56], [0.4, 3.95], [0.55, 3.8], [0.65, 3.7], [0.15, 3.7], [0.15, 3.55], [0.15, 3.4], [1, 3.4], [1.2, 3.1], [0.15, 3.1], [0.15, 2.95], [0.15, 2.8], [1.3, 2.8], [1.3, 2.65], [1.3, 2.5], [0.15, 2.5], [0.15, 2.35], [0.15, 2.2], [1.3, 2.2], [1.225, 2.05], [1.15, 1.9], [0.15, 1.9], [0.15, 1.75], [0.15, 1.6], [1, 1.6], [0.65, 1.3], [0.15, 1.3]],
        [[0, 5], [0, 3.73], [0, 2.46], [0, 1.19], [0, -0.08], [0, -1.35], [0, -2.62], [0, -3.89], [0, -5]]
    ],
    527: [
        [[-0.4, -3.95], [0.4, -3.95], [1.08, -3.54], [1.45, -2.89], [1.45, -2.11], [1.06, -1.44], [0.4, -1.05], [-0.4, -1.05], [-1.06, -1.44], [-1.45, -2.1], [-1.45, -2.9], [-1.06, -3.56], [-0.4, -3.95], [-0.55, -3.8], [-0.65, -3.7], [-0.15, -3.7], [-0.15, -3.55], [-0.15, -3.4], [-1, -3.4], [-1.2, -3.1], [-0.15, -3.1], [-0.15, -2.95], [-0.15, -2.8], [-1.3, -2.8], [-1.3, -2.65], [-1.3, -2.5], [-0.15, -2.5], [-0.15, -2.35], [-0.15, -2.2], [-1.3, -2.2], [-1.225, -2.05], [-1.15, -1.9], [-0.15, -1.9], [-0.15, -1.75], [-0.15, -1.6], [-1, -1.6], [-0.65, -1.3], [-0.15, -1.3]],
        [[-0.4, 1.05], [0.4, 1.05], [1.08, 1.46], [1.45, 2.11], [1.45, 2.89], [1.06, 3.56], [0.4, 3.95], [-0.4, 3.95], [-1.06, 3.56], [-1.45, 2.9], [-1.45, 2.1], [-1.06, 1.44], [-0.4, 1.05], [-0.55, 1.2], [-0.65, 1.3], [-0.15, 1.3], [-0.15, 1.45], [-0.15, 1.6], [-1, 1.6], [-1.2, 1.9], [-0.15, 1.9], [-0.15, 2.05], [-0.15, 2.2], [-1.3, 2.2], [-1.3, 2.35], [-1.3, 2.5], [-0.15, 2.5], [-0.15, 2.65], [-0.15, 2.8], [-1.3, 2.8], [-1.225, 2.95], [-1.15, 3.1], [-0.15, 3.1], [-0.15, 3.25], [-0.15, 3.4], [-1, 3.4], [-0.65, 3.7], [-0.15, 3.7]],
        [[0, 5], [0, 3.73], [0, 2.46], [0, 1.19], [0, -0.08], [0, -1.35], [0, -2.62], [0, -3.89], [0, -5]]
    ],
    528: [
        [[-1.5, -2.5], [-1.31, -3.23], [-0.77, -3.78], [-0.02, -4], [0.74, -3.82], [1.3, -3.28], [1.49, -2.51], [1.31, -1.77], [0.78, -1.22], [0.03, -1.02], [-0.71, -1.21], [-1.29, -1.76], [-1.49, -2.5], [-0.22, -2.5], [1.05, -2.5], [1.49, -2.5]],
        [[0, -5], [0, -4]],
        [[0, -1], [0, 0]]
    ],
    529: [
        [[-1.5, -2.5], [-1.29, -3.29], [-0.73, -3.81], [0, -4], [0.75, -3.81], [1.27, -3.29], [1.5, -2.5], [1.29, -1.72], [0.75, -1.23], [0, -1], [-0.7, -1.2], [-1.25, -1.69], [-1.5, -2.5], [-0.23, -2.5], [1.04, -2.5], [1.5, -2.5], [1.35, -2.35], [1.2, -2.2], [-0.07, -2.2], [-1.2, -2.2], [-1.1, -1.9], [0.17, -1.9], [1.1, -1.9], [0.9, -1.6], [-0.37, -1.6], [-0.9, -1.6], [-0.75, -1.45], [-0.6, -1.3], [0.5, -1.3], [0, -1], [0, 0]],
        [[0, -4], [0, -5]]
    ],
    530: [
        [[-1.5, -2.5], [-1.29, -1.71], [-0.73, -1.19], [0, -1], [0.75, -1.19], [1.27, -1.71], [1.5, -2.5], [1.29, -3.28], [0.75, -3.77], [0, -4], [-0.7, -3.8], [-1.25, -3.31], [-1.5, -2.5], [-0.23, -2.5], [1.04, -2.5], [1.5, -2.5], [1.35, -2.65], [1.2, -2.8], [-0.07, -2.8], [-1.2, -2.8], [-1.1, -3.1], [0.17, -3.1], [1.1, -3.1], [0.9, -3.4], [-0.37, -3.4], [-0.9, -3.4], [-0.75, -3.55], [-0.6, -3.7], [0.5, -3.7], [0, -4], [0, -5]],
        [[0, -1], [0, 0]]
    ],
    531: [
        [[-1.5, 2.5], [-1.29, 3.29], [-0.73, 3.81], [0, 4], [0.75, 3.81], [1.27, 3.29], [1.5, 2.5], [1.29, 1.72], [0.75, 1.23], [0, 1], [-0.7, 1.2], [-1.25, 1.69], [-1.5, 2.5], [-0.23, 2.5], [1.04, 2.5], [1.5, 2.5], [1.35, 2.35], [1.2, 2.2], [-0.07, 2.2], [-1.2, 2.2], [-1.1, 1.9], [0.17, 1.9], [1.1, 1.9], [0.9, 1.6], [-0.37, 1.6], [-0.9, 1.6], [-0.75, 1.45], [-0.6, 1.3], [0.5, 1.3], [0, 1], [0, 0]],
        [[0, 4], [0, 5]]
    ],
    532: [
        [[1.5, 2.5], [1.29, 1.71], [0.73, 1.19], [0, 1], [-0.75, 1.19], [-1.27, 1.71], [-1.5, 2.5], [-1.29, 3.28], [-0.75, 3.77], [0, 4], [0.7, 3.8], [1.25, 3.31], [1.5, 2.5], [0.23, 2.5], [-1.04, 2.5], [-1.5, 2.5], [-1.35, 2.65], [-1.2, 2.8], [0.07, 2.8], [1.2, 2.8], [1.1, 3.1], [-0.17, 3.1], [-1.1, 3.1], [-0.9, 3.4], [0.37, 3.4], [0.9, 3.4], [0.75, 3.55], [0.6, 3.7], [-0.5, 3.7], [0, 4], [0, 5]],
        [[0, 1], [0, 0]]
    ],
    533: [
        [[2, -1], [-2, -3], [-2.5, -3], [-2.5, -1.5], [-2.5, -1], [2.5, -1], [2.5, -2.5], [2.5, -3], [-2, -3], [-1.6, -2.7], [-2.3, -2.7], [-2.3, -2.4], [-1.1, -2.4], [-0.4, -2.1], [-1.9, -2.1], [-2.3, -2.1], [-2.3, -1.8], [-0.8, -1.8], [-0.6, -1.8], [-1.2, -1.5], [-2.3, -1.5], [-2.3, -1.2], [-1.9, -1.2], [-2, -1], [2, -3], [1.6, -2.7], [2.3, -2.7], [2.3, -2.4], [1.1, -2.4], [0.4, -2.1], [1.9, -2.1], [2.3, -2.1], [2.3, -1.8], [0.8, -1.8], [0.6, -1.8], [1.2, -1.5], [2.3, -1.5], [2.3, -1.2], [1.9, -1.2], [2, -1]],
        [[0, -1], [0, 0]]
    ],
    534: [
        [[-0.5, -1.5], [0, -0.5], [0.5, -1.5]],
        [[1.5, -0.5], [0, -0.5], [-1.5, -0.5], [-1.5, 0.5], [0, 0.5], [1.5, 0.5], [1.5, -0.5], [1.3, -0.2], [-0.2, -0.2], [-1.3, -0.2], [-1.3, 0.2], [0.2, 0.2], [1.3, 0.2]]
    ],
    535: [
        [[-0.75, 0.75], [0.75, 0.75], [0.75, -0.75], [-0.75, 0.75], [-0.75, -0.75], [0.75, 0.75]],
        [[0.75, -0.75], [-0.75, -0.75]]
    ],
    536: [
        [[-1, -0.5], [-1.4, -0.3], [-1.5, 0.1], [-1.2, 0.45], [-0.8, 0.45], [-0.5, 0.1], [-0.6, -0.3], [-1, -0.5], [-0.7, -0.15], [-1.3, -0.15], [-1.3, 0.15], [-0.75, 0.15], [-1.1, 0.4]],
        [[0.5, 2], [0.5, -2], [1.25, -2], [1.5, -2], [1.5, 2], [0.75, 2], [0.5, 2], [0.65, 1.7], [1.35, 1.7], [1.35, 1.4], [0.65, 1.4], [0.65, 1.1], [1.35, 1.1], [1.35, 0.8], [0.65, 0.8], [0.65, 0.5], [1.35, 0.5], [1.35, 0.2], [0.65, 0.2], [0.65, -0.1], [1.35, -0.1], [1.35, -0.4], [0.65, -0.4], [0.65, -0.7], [1.35, -0.7], [1.35, -1], [0.65, -1], [0.65, -1.3], [1.35, -1.3], [1.35, -1.6], [0.65, -1.6], [0.65, -1.85], [1.35, -1.85]]
    ],
    537: [
        [[0, 1], [0.4, 1.2], [0.5, 1.6], [0.25, 1.95], [-0.2, 1.95], [-0.5, 1.6], [-0.4, 1.2], [0, 1], [0.3, 1.4], [-0.3, 1.4], [-0.3, 1.7], [0.2, 1.7], [-0.1, 1.85]],
        [[-1, 0], [1, 0], [1, -2], [-1, -2], [-1, 0], [-0.8, -0.3], [0.8, -0.3], [0.8, -0.6], [-0.8, -0.6], [-0.8, -0.9], [0.8, -0.9], [0.8, -1.2], [-0.8, -1.2], [-0.8, -1.5], [0.8, -1.5], [0.8, -1.8], [-0.8, -1.8]]
    ],
    538: [
        [[-0.5, -3.7], [1.5, -5]],
        [[1, -4.65], [1, -2], [0.25, -2], [0, -2]],
        [[0, -4], [0, 0]],
        [[-0.5, 0], [0.25, 0], [0.5, 0]]
    ],
    539: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[3.5, -1], [4.5, 1]]
    ],
    540: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[3, -1], [4, 1]],
        [[5, 1], [4, -1]]
    ],
    541: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[2.5, -1], [3.5, 1]],
        [[4.5, 1], [3.5, -1]],
        [[4.5, -1], [5.5, 1]]
    ],
    542: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[2, -1], [3, 1]],
        [[4, 1], [3, -1]],
        [[4, -1], [5, 1]],
        [[6, 1], [5, -1]]
    ],
    543: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[4, -1], [4, 1]]
    ],
    544: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[3.5, -1], [3.5, 1]],
        [[4.5, 1], [4.5, -1]]
    ],
    545: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[3, -1], [3, 1]],
        [[4, 1], [4, -1]],
        [[5, -1], [5, 1]]
    ],
    546: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [2, 0], [2, 1], [5.75, 1], [6, 1], [6, -1], [2.25, -1], [2, -1], [2, 0]],
        [[2.5, -1], [2.5, 1]],
        [[3.5, 1], [3.5, -1]],
        [[4.5, -1], [4.5, 1]],
        [[5.5, 1], [5.5, -1]]
    ],
    547: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[4.5, 1], [3.5, -1]],
        [[2.9, -0.3], [2.3, 0], [2.9, 0.3]]
    ],
    548: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[5, 1], [4, -1]],
        [[3, -1], [4, 1]],
        [[2.8, 0.3], [2.3, 0], [2.8, -0.3]]
    ],
    549: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[5.5, 1], [4.5, -1]],
        [[3.5, -1], [4.5, 1]],
        [[3.5, 1], [2.5, -1]],
        [[2.8, -0.3], [2.3, 0], [2.8, 0.3]]
    ],
    550: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2, -1], [3, 1]],
        [[4, 1], [3, -1]],
        [[4, -1], [5, 1]],
        [[6, 1], [5, -1]],
        [[5.7, 0], [2.3, 0]],
        [[2.8, -0.3], [2.3, 0], [2.8, 0.3]]
    ],
    551: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[4, 1], [4, -1]],
        [[2.8, -0.3], [2.3, 0], [2.8, 0.3]]
    ],
    552: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.5, 0], [5.7, 0]],
        [[4.5, -1], [4.5, 1]],
        [[3.5, 1], [3.5, -1]],
        [[2.9, -0.3], [2.4, 0], [2.9, 0.3]]
    ],
    553: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[5, -1], [5, 1]],
        [[4, 1], [4, -1]],
        [[3, -1], [3, 1]],
        [[2.8, 0.3], [2.3, 0], [2.8, -0.3]]
    ],
    554: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[5.5, -1], [5.5, 1]],
        [[4.5, 1], [4.5, -1]],
        [[3.5, -1], [3.5, 1]],
        [[2.5, 1], [2.5, -1]],
        [[2.8, -0.3], [2.3, 0], [2.8, 0.3]]
    ],
    555: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.3, 0], [5.7, 0]],
        [[2.8, -0.3], [2.3, 0], [2.8, 0.3]]
    ],
    556: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3.8, 0], [3.9, -0.15], [4.1, -0.15], [4.2, 0], [4.1, 0.15], [3.9, 0.15], [3.8, 0], [4.2, 0]]
    ],
    557: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3.3, 0], [3.4, -0.15], [3.6, -0.15], [3.7, 0], [3.6, 0.15], [3.4, 0.15], [3.3, 0], [3.7, 0]],
        [[4.3, 0], [4.4, -0.15], [4.6, -0.15], [4.7, 0], [4.6, 0.15], [4.4, 0.15], [4.3, 0], [4.7, 0]]
    ],
    558: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [6, 1], [6, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2.8, 0], [2.9, -0.15], [3.1, -0.2], [3.2, 0], [3.1, 0.15], [2.9, 0.15], [2.8, 0], [3.2, 0]],
        [[3.8, 0], [3.9, -0.15], [4.1, -0.15], [4.2, 0], [4.1, 0.15], [3.9, 0.15], [3.8, 0], [4.2, 0]],
        [[4.8, 0], [4.9, -0.15], [5.1, -0.15], [5.2, 0], [5.1, 0.15], [4.9, 0.15], [4.85, 0], [5.2, 0]]
    ],
    559: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, -0.75], [3, -1], [5, -1], [5, 1], [4, -1], [3.9, -0.5], [4.1, -0.5], [4.3, -0.2], [3.8, -0.2], [3.65, 0.1], [4.35, 0.1], [4.5, 0.4], [3.75, 0.4], [3.5, 0.4], [3.35, 0.7], [4.1, 0.7], [4.6, 0.7], [5, 1], [3, 1], [4, -1]],
        [[3, 0], [3, 0.75], [3, 1]]
    ],
    560: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0]],
        [[3, -1], [3, 1], [5, 1], [5, -1], [3, -1], [4, 1], [5, -1], [4.7, -0.7], [3.95, -0.7], [3.3, -0.7], [3.45, -0.4], [4.2, -0.4], [4.55, -0.4], [4.4, -0.1], [3.65, -0.1], [3.6, -0.1], [3.75, 0.2], [4.25, 0.2], [4.15, 0.5], [3.9, 0.5], [4, 0.7]]
    ],
    561: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, 0.75], [3, 1], [5, 1], [4, -1], [4.35, -0.7], [4.85, -0.7], [4.85, -0.4], [4.45, -0.4], [4.6, -0.1], [4.85, -0.1], [4.85, 0.2], [4.75, 0.2], [5, 1], [5, -1], [4.25, -1], [4, -1], [3, 1], [3.25, 0.2], [3.15, 0.2], [3.15, -0.1], [3.4, -0.1], [3.55, -0.4], [3.15, -0.4], [3.15, -0.7], [3.7, -0.7], [4, -1], [3.25, -1], [3, -1], [3, -0.25], [3, 0]]
    ],
    562: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, -0.75], [3, -1], [5, -1], [5, 1], [4.25, 1], [4, 1], [5, -1], [4.75, -0.2], [4.85, -0.2], [4.85, 0.1], [4.6, 0.1], [4.45, 0.4], [4.85, 0.4], [4.85, 0.7], [4.3, 0.7], [4, 1], [3, -1], [3.25, -0.2], [3.15, -0.2], [3.15, 0.1], [3.4, 0.1], [3.55, 0.4], [3.15, 0.4], [3.15, 0.7], [3.7, 0.7], [4, 1], [3.25, 1], [3, 1], [3, 0.25], [3, 0]]
    ],
    563: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.2, 0.75], [3.75, 1.3], [4.5, 1.5], [5.25, 1.3], [5.8, 0.75], [6, 0], [5.8, -0.75], [5.25, -1.3], [4.5, -1.5], [3.75, -1.3], [3.2, -0.75], [3, 0]],
        [[4.5, -1], [3.9, -0.8], [3.55, -0.3], [3.55, 0.3], [3.9, 0.8], [4.5, 1], [5.1, 0.8], [5.45, 0.3], [5.45, -0.3], [5.1, -0.8], [4.5, -1], [3.95, -0.6], [4.7, -0.6], [5.1, -0.6], [5.3, -0.3], [3.7, -0.3], [3.7, 0], [5.3, 0], [5.3, 0.3], [3.7, 0.3], [3.9, 0.6], [4.65, 0.6], [5.1, 0.6], [4.5, 0.9]]
    ],
    564: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [5, 0], [5, -0.75], [5, -0.8], [5.75, -0.8], [6, -0.8], [6, 3.2], [5.25, 3.2], [5, 3.2], [5, 0], [5.15, -0.4], [5.85, -0.4], [5.85, -0.1], [5.15, -0.1], [5.15, 0.2], [5.85, 0.2], [5.85, 0.5], [5.15, 0.5], [5.15, 0.8], [5.85, 0.8], [5.85, 1.1], [5.15, 1.1], [5.15, 1.4], [5.85, 1.4], [5.85, 1.7], [5.15, 1.7], [5.15, 2], [5.85, 2], [5.85, 2.3], [5.15, 2.3], [5.15, 2.6], [5.85, 2.6], [5.85, 2.9], [5.15, 2.9]]
    ],
    565: [
        [[0, 0.75], [0, 0], [0, -0.75]],
        [[0, 0], [5, 0], [5, -0.75], [5, -0.8], [5.75, -0.8], [6, -0.8], [6, 3.2], [5.25, 3.2], [5, 3.2], [5, 0], [5.15, -0.4], [5.85, -0.4], [5.85, -0.1], [5.15, -0.1], [5.15, 0.2], [5.85, 0.2], [5.85, 0.5], [5.15, 0.5], [5.15, 0.8], [5.85, 0.8], [5.85, 1.1], [5.15, 1.1], [5.15, 1.4], [5.85, 1.4], [5.85, 1.7], [5.15, 1.7], [5.15, 2], [5.85, 2], [5.85, 2.3], [5.15, 2.3], [5.15, 2.6], [5.85, 2.6], [5.85, 2.9], [5.15, 2.9]],
        [[1.5, 0.3], [3.5, 0.3], [3.5, 0.8], [1.5, 0.8], [1.5, 0.3], [1.65, 0.55], [3.35, 0.55]]
    ],
    566: [
        [[5, 0], [5, -0.75], [5, -0.8], [5.75, -0.8], [6, -0.8], [6, 3.2], [5.25, 3.2], [5, 3.2], [5, 0], [5.15, -0.4], [5.85, -0.4], [5.85, -0.1], [5.15, -0.1], [5.15, 0.2], [5.85, 0.2], [5.85, 0.5], [5.15, 0.5], [5.15, 0.8], [5.85, 0.8], [5.85, 1.1], [5.15, 1.1], [5.15, 1.4], [5.85, 1.4], [5.85, 1.7], [5.15, 1.7], [5.15, 2], [5.85, 2], [5.85, 2.3], [5.15, 2.3], [5.15, 2.6], [5.85, 2.6], [5.85, 2.9], [5.15, 2.9]],
        [[4.3, 3.2], [4.3, -0.8]],
        [[3.5, 0.3], [1.5, 0.3], [1.5, 0.8], [3.5, 0.8], [3.5, 0.3], [3.3, 0.55], [1.65, 0.55]],
        [[0, 0.75], [0, 0], [0, -0.75]]
    ],
    567: [
        [[5, 0], [5, -0.75], [5, -0.8], [5.75, -0.8], [6, -0.8], [6, 3.2], [5.25, 3.2], [5, 3.2], [5, 0], [5.15, -0.4], [5.85, -0.4], [5.85, -0.1], [5.15, -0.1], [5.15, 0.2], [5.85, 0.2], [5.85, 0.5], [5.15, 0.5], [5.15, 0.8], [5.85, 0.8], [5.85, 1.1], [5.15, 1.1], [5.15, 1.4], [5.85, 1.4], [5.85, 1.7], [5.15, 1.7], [5.15, 2], [5.85, 2], [5.85, 2.3], [5.15, 2.3], [5.15, 2.6], [5.85, 2.6], [5.85, 2.9], [5.15, 2.9]],
        [[3.5, 1.4], [3.5, 0.9], [1.5, 0.9], [1.5, 1.4], [3.5, 1.4], [3.3, 1.15], [1.7, 1.15]],
        [[1.5, 0.75], [1.5, 0], [1.5, -0.75], [2.95, 0], [1.5, 0.75], [1.75, 0.3], [2.2, 0.3], [2.2, -0.3], [1.7, -0.3], [1.55, -0.65]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    568: [
        [[0, -0.75], [0, 0.52], [0, 0.75]],
        [[0, 0], [1.27, 0], [1.75, 0], [1.9, -0.45], [2.36, -0.73], [2.87, -0.65], [3.19, -0.29], [3.21, 0.23], [2.9, 0.64], [2.39, 0.74], [1.96, 0.5], [1.75, 0]],
        [[1.5, 0.9], [1.5, 1.4], [2.77, 1.4], [3.5, 1.4], [3.5, 0.9], [2.23, 0.9], [1.5, 0.9], [1.65, 1.15], [2.92, 1.15], [3.35, 1.15]],
        [[3.2, 0], [4.47, 0], [5, 0], [5, -0.8], [6, -0.8], [6, 0.47], [6, 1.74], [6, 3.01], [6, 3.2], [5, 3.2], [5, 1.93], [5, 0.66], [5, 0], [5.2, -0.4], [5.8, -0.4], [5.8, -0.25], [5.8, -0.1], [5.2, -0.1], [5.2, 0.05], [5.2, 0.2], [5.8, 0.2], [5.8, 0.35], [5.8, 0.5], [5.2, 0.5], [5.2, 0.65], [5.2, 0.8], [5.8, 0.8], [5.8, 0.95], [5.8, 1.1], [5.2, 1.1], [5.2, 1.25], [5.2, 1.4], [5.8, 1.4], [5.8, 1.55], [5.8, 1.7], [5.2, 1.7], [5.2, 1.85], [5.2, 2], [5.8, 2], [5.8, 2.15], [5.8, 2.3], [5.2, 2.3], [5.2, 2.45], [5.2, 2.6], [5.8, 2.6], [5.8, 2.75], [5.8, 2.9], [5.2, 2.9]]
    ],
    569: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2.2, 0.6], [2.7, 0.95], [3.3, 0.95], [3.8, 0.6], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6, 0], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [3.8, -0.6], [3.3, -0.95], [2.7, -0.95], [2.2, -0.6], [2, 0]]
    ],
    570: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8, 0], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]],
        [[0, 0], [2, 0]]
    ],
    571: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.25, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10, 0], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]]
    ],
    572: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2.2, -0.6], [2.65, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.25, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]]
    ],
    573: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12.2, 0.6], [12.7, 0.95], [13.3, 0.95], [13.8, 0.6], [14, 0], [13.8, -0.6], [13.25, -0.95], [12.7, -0.95], [12.2, -0.6], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]]
    ],
    574: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.25, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.65, -0.95], [11.35, -0.95], [11.8, -0.6], [12.2, 0.6], [12.7, 0.95], [13.3, 0.95], [13.8, 0.6], [14.2, -0.6], [14.7, -0.95], [15.3, -0.95], [15.8, -0.6], [16, 0], [15.8, 0.6], [15.3, 0.95], [14.7, 0.95], [14.2, 0.6], [13.8, -0.6], [13.3, -0.95], [12.7, -0.95], [12.2, -0.6], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.25, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.25, 0.95], [2.65, 0.95], [2.2, 0.55], [2, 0]]
    ],
    575: [
        [[0, -1], [0, 1]],
        [[0, 0], [0.2, -0.6], [0.7, -0.95], [1.3, -0.95], [1.8, -0.6], [2.2, 0.6], [2.7, 0.95], [3.3, 0.95], [3.8, 0.6], [4, 0], [3.8, -0.6], [3.3, -0.95], [2.7, -0.95], [2.2, -0.6], [1.8, 0.6], [1.3, 0.95], [0.7, 0.95], [0.2, 0.6], [0, 0]]
    ],
    576: [
        [[0, -1], [0, 1]],
        [[0, 0], [0.2, -0.6], [0.7, -0.95], [1.3, -0.95], [1.8, -0.6], [2.2, 0.6], [2.7, 0.95], [3.3, 0.95], [3.8, 0.6], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6, 0], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [3.8, -0.6], [3.3, -0.95], [2.7, -0.95], [2.2, -0.6], [1.8, 0.6], [1.3, 0.95], [0.7, 0.95], [0.2, 0.6], [0, 0]]
    ],
    577: [
        [[0, -2], [0, 2]],
        [[0, 1], [0.2, 1.6], [0.7, 1.95], [1.3, 1.95], [1.8, 1.6], [2.2, 0.4], [2.7, 0.05], [3.3, 0.05], [3.8, 0.4], [4, 1], [3.8, 1.6], [3.3, 1.95], [2.7, 1.95], [2.2, 1.6], [1.8, 0.4], [1.3, 0.05], [0.7, 0.05], [0.2, 0.4], [0, 1]],
        [[0, -1], [0.2, -0.4], [0.7, -0.05], [1.3, -0.05], [1.8, -0.4], [2.2, -1.6], [2.7, -1.95], [3.3, -1.95], [3.8, -1.6], [4, -1], [3.8, -0.4], [3.3, -0.05], [2.7, -0.05], [2.2, -0.4], [1.8, -1.6], [1.3, -1.95], [0.7, -1.95], [0.2, -1.6], [0, -1]]
    ],
    578: [
        [[0, -2], [0, 2]],
        [[0, 1], [0.2, 1.6], [0.7, 1.95], [1.3, 1.95], [1.8, 1.6], [2.2, 0.4], [2.7, 0.05], [3.3, 0.05], [3.8, 0.4], [4.2, 1.6], [4.7, 1.95], [5.3, 1.95], [5.8, 1.6], [6, 1], [5.8, 0.4], [5.3, 0.05], [4.7, 0.05], [4.2, 0.4], [3.8, 1.6], [3.3, 1.95], [2.7, 1.95], [2.2, 1.6], [1.8, 0.4], [1.3, 0.05], [0.7, 0.05], [0.2, 0.4], [0, 1]],
        [[0, -1], [0.2, -0.4], [0.7, -0.05], [1.3, -0.05], [1.8, -0.4], [2.2, -1.6], [2.7, -1.95], [3.3, -1.95], [3.8, -1.6], [4, -1], [3.8, -0.4], [3.3, -0.05], [2.7, -0.05], [2.2, -0.4], [1.8, -1.6], [1.3, -1.95], [0.7, -1.95], [0.2, -1.6], [0, -1]]
    ],
    579: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [2.75, 1], [3, 1], [3, -1], [2.25, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, 0], [3.2, -0.6], [3.7, -0.95], [4.3, -0.95], [4.8, -0.6], [5.2, 0.6], [5.7, 0.95], [6.3, 0.95], [6.8, 0.6], [7.2, -0.6], [7.7, -0.95], [8.3, -0.95], [8.8, -0.6], [9, 0], [8.8, 0.6], [8.3, 0.95], [7.7, 0.95], [7.2, 0.6], [6.8, -0.6], [6.3, -0.95], [5.7, -0.95], [5.2, -0.6], [4.8, 0.6], [4.3, 0.95], [3.7, 0.95], [3.2, 0.6], [3, 0]]
    ],
    580: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [2.75, 1], [3, 1], [3, -1], [2.25, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, 0], [3.2, 0.6], [3.7, 0.95], [4.3, 0.95], [4.8, 0.6], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11, 0], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [4.8, -0.6], [4.3, -0.95], [3.7, -0.95], [3.2, -0.6], [3, 0]]
    ],
    581: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [2.75, 1], [3, 1], [3, -1], [2.25, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, 0], [3.2, -0.6], [3.7, -0.95], [4.3, -0.95], [4.8, -0.6], [5.2, 0.6], [5.7, 0.95], [6.3, 0.95], [6.8, 0.6], [7.2, -0.6], [7.7, -0.95], [8.3, -0.95], [8.8, -0.6], [9.2, 0.6], [9.7, 0.95], [10.3, 0.95], [10.8, 0.6], [11.2, -0.6], [11.7, -0.95], [12.3, -0.95], [12.8, -0.6], [13, 0], [12.8, 0.6], [12.3, 0.95], [11.7, 0.95], [11.2, 0.6], [10.8, -0.6], [10.3, -0.95], [9.7, -0.95], [9.2, -0.6], [8.8, 0.6], [8.3, 0.95], [7.7, 0.95], [7.2, 0.6], [6.8, -0.6], [6.3, -0.95], [5.7, -0.95], [5.2, -0.6], [4.8, 0.6], [4.3, 0.95], [3.7, 0.95], [3.2, 0.6], [3, 0]]
    ],
    582: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [2.75, 1], [3, 1], [3, -1], [2.25, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, 0], [3.2, -0.6], [3.7, -0.95], [4.3, -0.95], [4.8, -0.6], [5.2, 0.6], [5.7, 0.95], [6.3, 0.95], [6.8, 0.6], [7.2, -0.6], [7.7, -0.95], [8.3, -0.95], [8.8, -0.6], [9.2, 0.6], [9.7, 0.95], [10.3, 0.95], [10.8, 0.6], [11.2, -0.6], [11.7, -0.95], [12.3, -0.95], [12.8, -0.6], [13.2, 0.6], [13.7, 0.95], [14.3, 0.95], [14.8, 0.6], [15, 0], [14.8, -0.6], [14.3, -0.95], [13.7, -0.95], [13.2, -0.6], [12.8, 0.6], [12.3, 0.95], [11.7, 0.95], [11.2, 0.6], [10.8, -0.6], [10.3, -0.95], [9.7, -0.95], [9.2, -0.6], [8.8, 0.6], [8.3, 0.95], [7.7, 0.95], [7.2, 0.6], [6.8, -0.6], [6.3, -0.95], [5.7, -0.95], [5.2, -0.6], [4.8, 0.6], [4.3, 0.95], [3.7, 0.95], [3.2, 0.6], [3, 0]]
    ],
    583: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10, 0], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, -1], [3, 1]]
    ],
    584: [
        [[4, 0], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, -1], [3, 1]]
    ],
    585: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14, 0], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, -1], [3, 1]]
    ],
    586: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14.2, 0.6], [14.7, 0.95], [15.3, 0.95], [15.8, 0.6], [16, 0], [15.8, -0.6], [15.3, -0.95], [14.7, -0.95], [14.2, -0.6], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]],
        [[3, -1], [3, 1]]
    ],
    587: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10, 0], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]]
    ],
    588: [
        [[4, 0], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]]
    ],
    589: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14, 0], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]]
    ],
    590: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14.2, 0.6], [14.7, 0.95], [15.3, 0.95], [15.8, 0.6], [16, 0], [15.8, -0.6], [15.3, -0.95], [14.7, -0.95], [14.2, -0.6], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0]]
    ],
    591: [
        [[2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8, 0], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[8, -1], [8, 1], [11, 1], [11, -1], [8, -1]],
        [[8.5, 0], [10.5, 0]]
    ],
    592: [
        [[2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.25, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10, 0], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[10, -1], [10, 1], [13, 1], [13, -1], [10, -1]],
        [[10.5, 0], [12.5, 0]]
    ],
    593: [
        [[2, 0], [2.2, -0.6], [2.65, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.25, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[12.5, 0], [14.5, 0]],
        [[12, -1], [12, 1], [15, 1], [15, -1], [12, -1]]
    ],
    594: [
        [[2, 0], [2.2, -0.6], [2.7, -0.95], [3.3, -0.95], [3.8, -0.6], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12.2, 0.6], [12.7, 0.95], [13.3, 0.95], [13.8, 0.6], [14, 0], [13.8, -0.6], [13.25, -0.95], [12.7, -0.95], [12.2, -0.6], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [3.8, 0.6], [3.3, 0.95], [2.7, 0.95], [2.2, 0.6], [2, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[14, -1], [14, 1], [17, 1], [17, -1], [14, -1]],
        [[14.5, 0], [16.5, 0]]
    ],
    595: [
        [[5, 0], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11, 0], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [5, 0]],
        [[4.5, -0.5], [2.5, -0.5]],
        [[2.5, 0.5], [4.5, 0.5]],
        [[2, 0], [2, -0.75], [2, -1], [5, -1], [5, 1], [2, 1], [2, 0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    596: [
        [[5, 0], [5.2, 0.6], [5.7, 0.95], [6.3, 0.95], [6.8, 0.6], [7.2, -0.6], [7.7, -0.95], [8.3, -0.95], [8.8, -0.6], [9.2, 0.6], [9.7, 0.95], [10.3, 0.95], [10.8, 0.6], [11.2, -0.6], [11.7, -0.95], [12.3, -0.95], [12.8, -0.6], [13, 0], [12.8, 0.6], [12.3, 0.95], [11.7, 0.95], [11.2, 0.6], [10.8, -0.6], [10.3, -0.95], [9.7, -0.95], [9.2, -0.6], [8.8, 0.6], [8.3, 0.95], [7.7, 0.95], [7.2, 0.6], [6.8, -0.6], [6.3, -0.95], [5.7, -0.95], [5.2, -0.6], [5, 0]],
        [[4.5, -0.5], [2.5, -0.5]],
        [[2.5, 0.5], [4.5, 0.5]],
        [[2, 0], [2, 0.75], [2, 1], [5, 1], [5, -1], [2, -1], [2, -0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    597: [
        [[5, 0], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11.2, 0.6], [11.7, 0.95], [12.3, 0.95], [12.8, 0.6], [13.2, -0.6], [13.7, -0.95], [14.3, -0.95], [14.8, -0.6], [15, 0], [14.8, 0.6], [14.3, 0.95], [13.7, 0.95], [13.2, 0.6], [12.8, -0.6], [12.3, -0.95], [11.7, -0.95], [11.2, -0.6], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [5, 0]],
        [[4.5, -0.5], [2.5, -0.5]],
        [[2.5, 0.5], [4.5, 0.5]],
        [[2, 0], [2, 0.75], [2, 1], [5, 1], [5, -1], [2, -1], [2, -0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    598: [
        [[5, 0], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11.2, 0.6], [11.7, 0.95], [12.3, 0.95], [12.8, 0.6], [13.2, -0.6], [13.7, -0.95], [14.3, -0.95], [14.8, -0.6], [15.2, 0.6], [15.7, 0.95], [16.3, 0.95], [16.8, 0.6], [17, 0], [16.8, -0.6], [16.3, -0.95], [15.7, -0.95], [15.2, -0.6], [14.8, 0.6], [14.3, 0.95], [13.7, 0.95], [13.2, 0.6], [12.8, -0.6], [12.3, -0.95], [11.7, -0.95], [11.2, -0.6], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [5, 0]],
        [[4.5, -0.5], [2.55, -0.5]],
        [[2.55, 0.5], [4.5, 0.5]],
        [[2, 0], [2, 0.75], [2, 1], [5, 1], [5, -1], [2, -1], [2, -0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    599: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10, 0], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[3, -0.5], [3.4, -0.3], [3.5, 0.1], [3.2, 0.45], [2.8, 0.45], [2.5, 0.1], [2.6, -0.3], [3, -0.5], [3.3, -0.1], [2.7, -0.1], [2.75, 0.2], [3.25, 0.2]],
        [[2, 0], [2, -0.75], [2, -1], [4, -1], [4, 1], [2, 1], [2, 0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    600: [
        [[4, 0], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [4, 0]],
        [[3, -0.5], [2.6, -0.3], [2.5, 0.1], [2.8, 0.45], [3.2, 0.45], [3.45, 0.2], [3.4, -0.3], [3, -0.5], [2.7, -0.15], [3.3, -0.15], [3.3, 0.2], [2.7, 0.2]],
        [[2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    601: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14, 0], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[3, -0.5], [2.6, -0.3], [2.5, 0.1], [2.8, 0.45], [3.2, 0.45], [3.5, 0.1], [3.4, -0.3], [3, -0.5], [2.7, -0.15], [3.25, -0.15], [3.3, 0.15], [2.7, 0.15]],
        [[2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    602: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14.2, 0.6], [14.7, 0.95], [15.3, 0.95], [15.8, 0.6], [16, 0], [15.8, -0.6], [15.3, -0.95], [14.7, -0.95], [14.2, -0.6], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[3, -0.5], [2.6, -0.3], [2.5, 0.1], [2.8, 0.45], [3.2, 0.45], [3.45, 0.15], [3.4, -0.3], [3, -0.5], [2.7, -0.15], [3.25, -0.15], [3.3, 0.15], [2.7, 0.15]],
        [[2, 0], [2, 0.75], [2, 1], [4, 1], [4, -1], [2, -1], [2, -0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    603: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10, 0], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[3, -1], [3, 1]]
    ],
    604: [
        [[4, 0], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[3, -1], [3, 1]]
    ],
    605: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14, 0], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[3, -1], [3, 1]]
    ],
    606: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14.2, 0.6], [14.7, 0.95], [15.3, 0.95], [15.8, 0.6], [16, 0], [15.8, -0.6], [15.3, -0.95], [14.7, -0.95], [14.2, -0.6], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[3, -1], [3, 1]]
    ],
    607: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [2, 0], [2, 0.75], [2, 1], [4, 1], [4, 0.25], [4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8, 0], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0], [4, -0.75], [4, -1], [2, -1], [2, -0.25], [2, 0]],
        [[2, -1], [4, 1]],
        [[4, -1], [2, 1]]
    ],
    608: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10, 0], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[4, 1], [2, -1]],
        [[4, -1], [2, 1]],
        [[2, 0], [2, -0.75], [2, -1], [4, -1], [4, 1], [2, 1], [2, 0.25], [2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    609: [
        [[4, 0], [4.2, 0.6], [4.7, 0.95], [5.3, 0.95], [5.8, 0.6], [6.2, -0.6], [6.7, -0.95], [7.3, -0.95], [7.8, -0.6], [8.2, 0.6], [8.7, 0.95], [9.3, 0.95], [9.8, 0.6], [10.2, -0.6], [10.7, -0.95], [11.3, -0.95], [11.8, -0.6], [12, 0], [11.8, 0.6], [11.3, 0.95], [10.7, 0.95], [10.2, 0.6], [9.8, -0.6], [9.3, -0.95], [8.7, -0.95], [8.2, -0.6], [7.8, 0.6], [7.3, 0.95], [6.7, 0.95], [6.2, 0.6], [5.8, -0.6], [5.3, -0.95], [4.7, -0.95], [4.2, -0.6], [4, 0]],
        [[4, 1], [2, -1]],
        [[4, -1], [2, 1], [4, 1], [4, -1], [2, -1], [2, 1]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    610: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14, 0], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[4, -1], [2, 1]],
        [[4, 1], [2, -1], [4, -1], [4, 1], [2, 1], [2, -1]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    611: [
        [[4, 0], [4.2, -0.6], [4.7, -0.95], [5.3, -0.95], [5.8, -0.6], [6.2, 0.6], [6.7, 0.95], [7.3, 0.95], [7.8, 0.6], [8.2, -0.6], [8.7, -0.95], [9.3, -0.95], [9.8, -0.6], [10.2, 0.6], [10.7, 0.95], [11.3, 0.95], [11.8, 0.6], [12.2, -0.6], [12.7, -0.95], [13.3, -0.95], [13.8, -0.6], [14.2, 0.6], [14.7, 0.95], [15.3, 0.95], [15.8, 0.6], [16, 0], [15.8, -0.6], [15.3, -0.95], [14.7, -0.95], [14.2, -0.6], [13.8, 0.6], [13.3, 0.95], [12.7, 0.95], [12.2, 0.6], [11.8, -0.6], [11.3, -0.95], [10.7, -0.95], [10.2, -0.6], [9.8, 0.6], [9.3, 0.95], [8.7, 0.95], [8.2, 0.6], [7.8, -0.6], [7.3, -0.95], [6.7, -0.95], [6.2, -0.6], [5.8, 0.6], [5.3, 0.95], [4.7, 0.95], [4.2, 0.6], [4, 0]],
        [[4, -1], [2, 1]],
        [[4, 1], [2, -1], [4, -1], [4, 1], [2, 1], [2, -1]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    612: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.75, 0.75], [4.5, 1.5], [5.25, 0.75], [6, 0], [5.25, -0.75], [4.5, -1.5], [3.75, -0.75], [3, 0]],
        [[4.5, -1], [3.75, -0.25], [3.5, 0], [4.25, 0.75], [4.5, 1], [5.25, 0.25], [5.5, 0], [4.75, -0.75], [4.5, -1], [4.2, -0.5], [4.8, -0.5], [5.1, -0.2], [4.35, -0.2], [3.9, -0.2], [3.8, 0.1], [4.55, 0.1], [5.2, 0.1], [4.9, 0.4], [4.15, 0.4], [4.1, 0.4], [4.4, 0.7], [4.6, 0.7]]
    ],
    613: [
        [[5, 0], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11, 0], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [5, 0], [4.25, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    614: [
        [[5, 0], [5.2, 0.6], [5.7, 0.95], [6.3, 0.95], [6.8, 0.6], [7.2, -0.6], [7.7, -0.95], [8.3, -0.95], [8.8, -0.6], [9.2, 0.6], [9.7, 0.95], [10.3, 0.95], [10.8, 0.6], [11.2, -0.6], [11.7, -0.95], [12.3, -0.95], [12.8, -0.6], [13, 0], [12.8, 0.6], [12.3, 0.95], [11.7, 0.95], [11.2, 0.6], [10.8, -0.6], [10.3, -0.95], [9.7, -0.95], [9.2, -0.6], [8.8, 0.6], [8.3, 0.95], [7.7, 0.95], [7.2, 0.6], [6.8, -0.6], [6.3, -0.95], [5.7, -0.95], [5.2, -0.6], [5, 0], [4.25, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    615: [
        [[5, 0], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11.2, 0.6], [11.7, 0.95], [12.3, 0.95], [12.8, 0.6], [13.2, -0.6], [13.7, -0.95], [14.3, -0.95], [14.8, -0.6], [15, 0], [14.8, 0.6], [14.3, 0.95], [13.7, 0.95], [13.2, 0.6], [12.8, -0.6], [12.3, -0.95], [11.7, -0.95], [11.2, -0.6], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [5, 0], [4.25, 0], [4, 0], [4, -0.75], [4, -1], [2, -1], [2, 1], [4, 1], [4, 0.25], [4, 0]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    616: [
        [[5, 0], [5.2, -0.6], [5.7, -0.95], [6.3, -0.95], [6.8, -0.6], [7.2, 0.6], [7.7, 0.95], [8.3, 0.95], [8.8, 0.6], [9.2, -0.6], [9.7, -0.95], [10.3, -0.95], [10.8, -0.6], [11.2, 0.6], [11.7, 0.95], [12.3, 0.95], [12.8, 0.6], [13.2, -0.6], [13.7, -0.95], [14.3, -0.95], [14.8, -0.6], [15.2, 0.6], [15.7, 0.95], [16.3, 0.95], [16.8, 0.6], [17, 0], [16.8, -0.6], [16.3, -0.95], [15.7, -0.95], [15.2, -0.6], [14.8, 0.6], [14.3, 0.95], [13.7, 0.95], [13.2, 0.6], [12.8, -0.6], [12.3, -0.95], [11.7, -0.95], [11.2, -0.6], [10.8, 0.6], [10.3, 0.95], [9.7, 0.95], [9.2, 0.6], [8.8, -0.6], [8.3, -0.95], [7.7, -0.95], [7.2, -0.6], [6.8, 0.6], [6.3, 0.95], [5.7, 0.95], [5.2, 0.6], [5, 0], [4.25, 0], [4, 0], [4, 0.75], [4, 1], [2, 1], [2, -1], [4, -1], [4, -0.25], [4, 0]],
        [[2, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    617: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.2, -0.75], [3.75, -1.3], [4.5, -1.5], [5.25, -1.3], [5.8, -0.75], [6, 0], [5.8, 0.7], [5.3, 1.3], [4.5, 1.5], [3.75, 1.3], [3.2, 0.8], [3, 0]],
        [[4, -1.35], [4, 1.35], [4.75, 1.35], [5, 1.35], [5, -1.35], [4.25, -1.35], [4.2, -1.35], [4.2, -1.05], [4.8, -1.05], [4.8, -0.75], [4.2, -0.75], [4.2, -0.45], [4.8, -0.45], [4.8, -0.15], [4.2, -0.15], [4.2, 0.15], [4.8, 0.15], [4.8, 0.45], [4.2, 0.45], [4.2, 0.75], [4.8, 0.75], [4.8, 1.05], [4.2, 1.05], [4.2, 1.35]]
    ],
    618: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [6.1, -1.5], [6.1, -1], [4, 0], [6.1, 1], [6.1, 1.5], [3, 0]],
        [[6, -1.2], [5.65, -1.2], [5.05, -0.9], [5.65, -0.9], [5.05, -0.6], [4.45, -0.6], [3.85, -0.3], [4.45, -0.3], [3.85, 0], [3.15, 0], [3.8, 0.3], [4.45, 0.3], [5.1, 0.6], [4.4, 0.6], [5.05, 0.9], [5.75, 0.9], [6, 1.2], [5.65, 1.2]]
    ],
    619: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1], [6.75, 1], [8, 1], [8, -1], [4.25, -1], [3, -1], [3, 0]],
        [[3.5, -0.5], [7.25, -0.5], [7.5, -0.5], [7.5, 0.5], [3.75, 0.5], [3.5, 0.5], [3.5, -0.5]]
    ],
    620: [
        [[0, -0.75], [0, 0.52], [0, 0.75]],
        [[0, 0], [1.27, 0], [2.54, 0], [3, 0], [3.19, 0.58], [3.69, 0.94], [4.3, 0.94], [4.81, 0.59], [5, 0], [4.81, -0.59], [4.3, -0.95], [3.7, -0.95], [3.2, -0.6], [3, 0]],
        [[1.35, -0.35], [0.65, 0.35]],
        [[0.65, -0.35], [1.35, 0.35]]
    ],
    621: [
        [[-2, 0], [-1.8, -0.6], [-1.3, -0.95], [-0.7, -0.95], [-0.2, -0.6], [0, 0], [-0.2, 0.6], [-0.7, 0.95], [-1.3, 0.95], [-1.8, 0.6], [-2, 0], [-4, 0]],
        [[-3.65, -0.35], [-4.35, 0.35]],
        [[-3.65, 0.35], [-4.35, -0.35]]
    ],
    622: [
        [[0, 0.3], [5, 0.3], [5, -0.3], [0, -0.3], [0, 0.3]]
    ],
    623: [
        [[3, -0.3], [1.5, -0.3], [0, -0.3], [0, 0.3], [5, 0.3], [5, -0.3], [3.5, -0.3], [3, -0.3], [3, 0.3], [3.2, 0], [4.7, 0], [4.8, 0]]
    ],
    624: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [6, 0], [6, -0.75], [6, -1], [3, -1], [3, 1], [6, 1], [6, 0.25], [6, 0], [5.8, 0.2], [3.2, 0.2], [3.2, -0.2], [5.8, -0.2], [6, -0.35], [3, -0.35]],
        [[3, 0.35], [6, 0.35]]
    ],
    625: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.6, -0.2], [3.95, -0.7], [3.95, -1.3], [3.6, -1.8], [3, -2], [2.4, -1.8], [2.05, -1.3], [2.05, -0.7], [2.4, -0.2], [3.6, 0.2], [3.95, 0.7], [3.95, 1.3], [3.6, 1.8], [3, 2], [2.4, 1.8], [2.05, 1.3], [2.05, 0.7], [2.4, 0.2], [3, 0]],
        [[3.8, -0.3], [4.1, -0.8], [4.7, -1], [5.3, -0.8], [5.7, -0.3], [5.7, 0.3], [5.3, 0.85], [4.7, 1], [4.15, 0.8], [3.8, 0.3], [3.8, -0.3]]
    ],
    626: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1.75], [5.5, 1.75], [5.5, -1.75], [3, -1.75], [3, 0]]
    ],
    627: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.2, -0.75], [3.75, -1.3], [4.5, -1.5], [5.25, -1.3], [5.8, -0.75], [6, 0], [5.8, 0.75], [5.25, 1.3], [4.5, 1.5], [3.75, 1.3], [3.2, 0.75], [3, 0]]
    ],
    628: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, -1.75], [6.5, -1.75], [6.5, 1.75], [5.75, 1.75], [5.5, 1.75], [5.5, -1.75], [5.65, -1.5], [6.35, -1.5], [6.35, -1.2], [5.65, -1.2], [5.65, -0.9], [6.35, -0.9], [6.35, -0.6], [5.65, -0.6], [5.65, -0.3], [6.35, -0.3], [6.35, 0], [5.65, 0], [5.65, 0.3], [6.35, 0.3], [6.35, 0.6], [5.65, 0.6], [5.65, 0.9], [6.35, 0.9], [6.35, 1.2], [5.65, 1.2], [5.65, 1.5], [6.35, 1.5], [5.5, 1.75], [3, 1.75], [3, 0]]
    ],
    629: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, -1.75], [6.75, -1.75], [8, -1.75], [8, 1.75], [4.25, 1.75], [3, 1.75], [3, 0]],
        [[5.5, -1.75], [5.5, 1.75]]
    ],
    630: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.2, -0.75], [3.75, -1.3], [4.5, -1.5], [5.25, -1.3], [5.8, -0.75], [6, 0], [6, 1.75], [6.75, 1.75], [7, 1.75], [7, -1.75], [6.25, -1.75], [6, -1.75], [6, 0], [5.8, 0.75], [5.25, 1.3], [4.5, 1.5], [3.75, 1.3], [3.2, 0.75], [3, 0]],
        [[6.15, -1.5], [6.85, -1.5], [6.85, -1.2], [6.15, -1.2], [6.15, -0.9], [6.85, -0.9], [6.85, -0.6], [6.15, -0.6], [6.15, -0.3], [6.85, -0.3], [6.85, 0], [6.15, 0], [6.15, 0.3], [6.85, 0.3], [6.85, 0.6], [6.15, 0.6], [6.15, 0.9], [6.85, 0.9], [6.85, 1.2], [6.15, 1.2], [6.15, 1.5], [6.85, 1.5]]
    ],
    631: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, -1.75], [5.5, -1.75], [5.5, 0], [5.7, 0.8], [6.25, 1.3], [7, 1.5], [7.8, 1.3], [8.3, 0.8], [8.5, 0], [8.25, -0.8], [7.7, -1.3], [7, -1.5], [6.2, -1.3], [5.7, -0.7], [5.5, 0], [5.5, 1.75], [3, 1.75], [3, 0]]
    ],
    632: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, -1.75], [5.5, -1.75], [5.5, 1.75], [3, 1.75], [3, 0]],
        [[5.5, 0], [8, 0], [5.5, 1.2]]
    ],
    633: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [6, -1.75], [6, 1.75], [3, 0]]
    ],
    634: [
        [[3, 0], [3.2, -0.75], [3.75, -1.3], [4.5, -1.5], [4.5, 1.5], [3.75, 1.3], [3.2, 0.75], [3, 0], [0, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]]
    ],
    635: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1.75], [5.5, 1.75], [5.5, 0], [8.5, -1.75], [8.5, 1.75], [5.5, 0], [5.5, -1.75], [3, -1.75], [3, 0]]
    ],
    636: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3.2, -0.75], [3.75, -1.3], [4.5, -1.5], [5.25, -1.3], [5.8, -0.75], [6.2, 0.75], [6.7, 1.3], [7.5, 1.5], [7.5, -1.5], [6.8, -1.3], [6.2, -0.75], [5.8, 0.75], [5.25, 1.3], [4.5, 1.5], [3.75, 1.3], [3.2, 0.75], [3, 0]]
    ],
    637: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [6, -1.75], [6, 0], [6.2, 0.75], [6.75, 1.3], [7.5, 1.5], [7.5, -1.5], [6.75, -1.3], [6.2, -0.75], [6, 0], [6, 1.75], [3, 0]]
    ],
    638: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1], [5, 1], [5, -1], [3, -1], [3, 0]],
        [[3, -1], [5, 0], [3, 1]]
    ],
    639: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1], [5, 1], [5, -1], [3, -1], [3, 0], [5, -1]],
        [[5, 1], [3, 0]]
    ],
    640: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3.3, 0], [3.3, 1.6], [5.7, 0.8], [5.7, -0.8], [3.3, -1.6], [3.3, 0]],
        [[3, -2], [3, 2], [6, 1], [6, -1], [3, -2], [3.15, -1.8], [3.15, 1.8], [5.85, 0.9], [5.85, -0.9], [3.15, -1.8]]
    ],
    641: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1.75], [5.5, 1.75], [5.5, -1.75], [3, -1.75], [3, 0]],
        [[3, -1.25], [5.5, -0.75]],
        [[5.5, 0.25], [3, -0.25]],
        [[3, 0.75], [5.5, 1.25]]
    ],
    642: [
        [[5, 1], [3, 0]],
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [5, -1], [5, 1], [3, 0]]
    ],
    643: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [4, -1], [5, 0], [4, 1], [3, 0]]
    ],
    644: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1.75], [5.5, 1.75], [5.5, -1.75], [3, -1.75], [3, 0]],
        [[4, -1.3], [4.5, -1], [4, -0.7], [4.5, -0.4], [4, -0.1], [4.5, 0.2], [4, 0.5], [4.5, 0.8], [4, 1.1], [4.5, 1.35]]
    ],
    645: [
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[0, 0], [3, 0], [3, 1.75], [5.5, 1.75], [5.5, -1.75], [3, -1.75], [3, 0]],
        [[4.25, -1.2], [4.25, 1.15]]
    ],
    646: [
        [[0, -0.75], [0, 0.75]],
        [[0, 0], [3, 0], [3, -2], [4, -3], [5, -2], [5, 1.75], [5, 2], [4, 3], [3, 2], [3, 0]],
        [[3, -2], [4.875, 1.75], [5, 2]],
        [[3, 2], [4.875, -1.75], [5, -2]]
    ],
    647: [
        [[3, 0], [3.75, -0.75], [4, -1], [4.75, -0.25], [5, 0], [4.25, 0.75], [4, 1], [3.25, 0.25], [3, 0]],
        [[0, -0.75], [0, 0], [0, 0.75]],
        [[3.7, -0.7], [4.45, 0], [3.75, 0.75], [3.6, 0.4], [3.9, 0.4], [4.2, 0.1], [3.45, 0.1], [3.3, 0.1], [3.3, -0.2], [4.05, -0.2], [4.1, -0.2], [3.8, -0.5], [3.65, -0.5]]
    ],
    648: [
        [[-1, 1.5], [1, 1.5], [0, 0]]
    ],
    649: [
        [[-0.5, -1], [0.5, -1]],
        [[0, -1], [0, 1]],
        [[-0.5, 1], [0.5, 1]]
    ],
    650: [
        [[1, -1], [0, -1], [0, 1], [1, 1]]
    ],
    651: [
        [[-1, 0], [1, 0], [1, 2], [-1, 2], [-1, 0], [-0.8, 0.3], [0.8, 0.3], [0.8, 0.6], [-0.8, 0.6], [-0.8, 0.9], [0.8, 0.9], [0.8, 1.2], [-0.8, 1.2], [-0.8, 1.5], [0.8, 1.5], [0.8, 1.75], [-0.8, 1.75]]
    ],
    652: [
        [[0.6, 0.19], [0.95, 0.7], [0.95, 1.3], [0.59, 1.8], [0, 2], [-0.6, 1.8], [-0.95, 1.3], [-0.95, 0.7], [-0.6, 0.2], [0, 0]]
    ],
    653: [
        [[-1.5, 0], [0, 2.65], [1.5, 0]],
        [[-1, 0.9], [1, 0.9], [0.6, 1.2], [-0.15, 1.2], [-0.6, 1.2], [-0.4, 1.5], [0.35, 1.5], [0.4, 1.5], [0.3, 1.8], [-0.3, 1.8], [-0.1, 2.1], [0.1, 2.1], [0, 2.3]]
    ],
    654: [
        [[-0.5, 0], [0.25, 0], [0.5, 0]],
        [[0, 0], [0, -3.5]],
        [[-2, -5.85], [1, -2.35]],
        [[-1, -2.35], [2, -5.85]]
    ],
    655: [
        [[-0.5, 0], [0.25, 0], [0.5, 0]],
        [[-0.85, -2.2], [2.25, -5.85]],
        [[1.75, -5.85], [-1.1, -2.5]],
        [[0.8, -2.2], [-2.25, -5.85]],
        [[-1.75, -5.85], [1.1, -2.45]],
        [[0, 0], [0, -3.15]]
    ],
    656: [
        [[-0.8, 0], [0.75, 0]],
        [[0, 0], [0, -3.5], [-1, -5.5], [1, -5.5], [0, -3.5]],
        [[-0.15, -5], [0.1, -5], [0.25, -4.8], [0.15, -4.6], [-0.15, -4.6], [-0.25, -4.8], [-0.15, -5], [0.1, -4.6]]
    ],
    657: [
        [[0, -3.5], [-1, -5.5], [1, -5.5], [0, -3.5]],
        [[-0.8, 0], [0.75, 0]]
    ],
    658: [
        [[-1, -0.25], [-1, 0.25], [1, 0.25], [1, -0.25], [-1, -0.25], [-0.8, 0], [0.8, 0]]
    ],
    659: [
        [[-1, -0.25], [-1, 0.25], [1, 0.25], [1, -0.25], [-1, -0.25], [-0.8, 0], [0.8, 0]],
        [[0, -0.25], [0, -0.55], [-0.5, -0.55], [-0.5, -0.85]]
    ],
    660: [
        [[-1, -0.5], [-1, 0.5], [0.5, 0.5], [1, 0.5], [1, -0.5], [-0.5, -0.5], [-1, -0.5]],
        [[0, -0.5], [0, -0.9], [-0.6, -0.9], [-0.6, -1.3]]
    ],
    661: [
        [[-0.5, -0.5], [-0.5, 0.25], [-0.5, 0.5], [0.25, 0.5], [0.5, 0.5], [0.5, -0.25], [0.5, -0.5], [-0.25, -0.5], [-0.5, -0.5], [-0.3, -0.15], [0.3, -0.15], [0.3, 0.15], [-0.3, 0.15]]
    ],
    662: [
        [[-0.5, -0.5], [0.5, -0.5]],
        [[0, -0.5], [0, 0.5]],
        [[-0.5, 0.5], [0.5, 0.5]]
    ],
    663: [
        [[-0.2, -0.4], [-0.6, -0.5], [-0.95, -0.2], [-0.95, 0.2], [-0.6, 0.5], [-0.2, 0.4], [0.175, -0.35], [0.2, -0.4], [0.6, -0.5], [0.95, -0.2], [0.95, 0.25], [0.6, 0.5], [0.2, 0.4], [0, 0], [-0.3, -0.25], [-0.7, -0.25], [-0.8, 0], [-0.2, 0], [-0.25, 0.25], [-0.65, 0.25]],
        [[0.3, 0.25], [0.7, 0.25], [0.8, 0], [0.2, 0], [0.35, -0.25], [0.7, -0.25]]
    ],
    664: [
        [[-0.18, -0.39], [-0.61, -0.49], [-0.95, -0.22], [-0.95, 0.22], [-0.6, 0.49], [-0.19, 0.39], [0.19, -0.39], [0.61, -0.49], [0.95, -0.22], [0.95, 0.22], [0.61, 0.49], [0.19, 0.39], [0, 0]]
    ],
    665: [
        [[-1.5, 0], [-0.23, 0], [1.04, 0], [1.5, 0]],
        [[0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.21, 0.45], [0.23, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [-0.2, -0.2], [0.2, -0.2], [0.2, 0.2], [-0.2, 0.2]]
    ],
    666: [
        [[-1.5, 0], [0, 0], [1.5, 0]],
        [[-0.3, 0.3], [0.3, 0.3], [0.3, -0.3], [-0.3, -0.3], [-0.5, -0.5], [0.5, -0.5], [0.5, 0.5], [-0.5, 0.5], [-0.5, -0.5]]
    ],
    667: [
        [[-1.1, -0.5], [-1.45, -0.2], [-1.45, 0.2], [-1.1, 0.5], [-0.7, 0.4], [-0.5, 0], [-0.7, -0.4], [-1.1, -0.5], [-0.8, -0.2], [-1.25, -0.15], [-1.25, 0.15], [-0.75, 0.15], [-0.5, 0], [0.25, 0], [0.5, 0], [0.7, -0.4], [1.1, -0.5], [1.45, -0.2], [1.45, 0.2], [1.1, 0.5], [0.7, 0.4], [0.5, 0], [0.8, 0.2], [1.3, 0.2], [1.3, -0.15], [0.8, -0.15]]
    ],
    668: [
        [[0.5, -0.5], [0.5, 0.25], [0.5, 0.5], [1.25, 0.5], [1.5, 0.5], [1.5, -0.25], [1.5, -0.5], [0.75, -0.5], [0.5, -0.5], [0.7, -0.15], [1.3, -0.15], [1.3, 0.15], [0.7, 0.15]],
        [[-1.5, -0.5], [-1.5, 0.25], [-1.5, 0.5], [-0.75, 0.5], [-0.5, 0.5], [-0.5, -0.25], [-0.5, -0.5], [-1.25, -0.5], [-1.5, -0.5], [-1.3, -0.15], [-0.7, -0.15], [-0.7, 0.15], [-1.3, 0.15]],
        [[0.5, 0], [-0.25, 0], [-0.5, 0]]
    ],
    669: [
        [[-0.25, 0.15], [0.3, 0.15], [0.3, -0.15], [-0.25, -0.15], [0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [0, -4], [0.2, -4.6], [0.7, -4.95], [1.3, -4.95], [1.8, -4.6], [2, -4]],
        [[0.7, -4], [3.3, -4]],
        [[3, -4], [2.8, -3.4], [2.3, -3.05], [1.7, -3.05], [1.2, -3.4], [1, -4]]
    ],
    670: [
        [[-3, 1.5], [3, -1.5]]
    ],
    671: [
        [[-3, -1.5]]
    ],
    672: [
        [[3, -1.5]]
    ],
    673: [
        [[3, -0.8], [1.5, -0.8], [0, -0.8], [3, -1.8], [3, -0.8], [2.8, -1.1], [1.7, -1.1], [2.8, -1.5], [2.8, -1.1]]
    ],
    674: [
        [[-3, -0.8], [-1.5, -0.8], [0, -0.8], [-3, -1.8], [-3, -0.8], [-2.8, -1.1], [-1.7, -1.1], [-2.8, -1.5], [-2.8, -1.1]]
    ],
    675: [
        [[3, -0.8], [1.5, -0.8], [0, -0.8], [3, -1.8], [3, -0.8], [2.8, -1.1], [1.7, -1.1], [2.8, -1.4], [3, -1.8], [1.5, -3.3], [3, -4.8], [4.5, -3.3], [3, -1.8]],
        [[3, -2.3], [2, -3.3], [3, -4.3], [4, -3.3], [3, -2.3], [2.8, -2.7], [3.2, -2.7], [3.5, -3], [2.5, -3], [2.2, -3.3], [3.7, -3.3], [3.8, -3.3], [3.5, -3.6], [2.5, -3.6], [2.8, -3.9], [3.2, -3.9]]
    ],
    676: [
        [[-3, -2.3], [-2, -3.3], [-3, -4.3], [-4, -3.3], [-3, -2.3], [-2.8, -2.7], [-3.2, -2.7], [-3.5, -3], [-2.5, -3], [-2.2, -3.3], [-3.7, -3.3], [-3.8, -3.3], [-3.5, -3.6], [-2.5, -3.6], [-2.8, -3.9], [-3.2, -3.9]],
        [[-3, -0.8], [-1.5, -0.8], [0, -0.8], [-3, -1.8], [-3, -0.8], [-2.8, -1.1], [-1.7, -1.1], [-2.8, -1.4], [-3, -1.8], [-1.5, -3.3], [-3, -4.8], [-4.5, -3.3], [-3, -1.8]]
    ],
    677: [
        [[3, -0.8], [3, -1.8], [1.73, -1.38], [0.46, -0.96], [0, -0.8], [1.27, -0.8], [2.54, -0.8], [3, -0.8], [2.8, -1.1], [1.53, -1.1], [1.5, -1.1], [2.77, -1.39], [2.8, -1.4], [3, -1.8], [2.3, -2], [1.71, -2.54], [1.5, -3.3], [1.71, -4.09], [2.27, -4.61], [3, -4.8], [3.75, -4.61], [4.31, -4.05], [4.5, -3.3], [4.3, -2.55], [3.75, -2], [3, -1.8], [3.1, -1.9], [3.1, -3.17], [3.1, -4.44], [3.1, -4.7], [2.95, -4.7], [2.9, -4.7], [2.9, -3.43], [2.9, -2.16], [2.9, -1.9]]
    ],
    678: [
        [[-3, -0.8], [-3, -1.8], [-1.73, -1.38], [-0.46, -0.96], [0, -0.8], [-1.27, -0.8], [-2.54, -0.8], [-3, -0.8], [-2.8, -1.1], [-1.53, -1.1], [-1.5, -1.1], [-2.77, -1.39], [-2.8, -1.4], [-3, -1.8], [-2.3, -2], [-1.71, -2.54], [-1.5, -3.3], [-1.71, -4.09], [-2.27, -4.61], [-3, -4.8], [-3.75, -4.61], [-4.31, -4.05], [-4.5, -3.3], [-4.3, -2.55], [-3.75, -2], [-3, -1.8], [-3.1, -1.9], [-3.1, -3.17], [-3.1, -4.44], [-3.1, -4.7], [-2.95, -4.7], [-2.9, -4.7], [-2.9, -3.43], [-2.9, -2.16], [-2.9, -1.9]]
    ],
    679: [
        [[0, -1], [-1, -1], [-1, 1], [1, 1], [1, -1], [0, -1], [0, -2]],
        [[1, -2], [-1, -2]]
    ],
    680: [
        [[-2.5, -1], [0, -0.5], [2.5, -1], [2.5, 1], [0, 0.5], [-2.5, 1], [-2.5, -1]]
    ],
    681: [
        [[0, -0.5], [0, 0.5]],
        [[0, 0], [1.27, 0], [2.54, 0], [3.81, 0], [5, 0], [5, 1], [5.4, 1.2], [5.5, 1.6], [5.21, 1.94], [5.01, 1.96]]
    ],
    682: [
        [[2, 5], [2, 2.5], [0, 0], [-2, 2.5], [2, 2.5], [-2, 5], [-2, 2.5], [2, 5], [-2, 5]]
    ],
    683: [
        [[0, -1.5], [0, -2.5]],
        [[0, 1.5], [0, 2.5]],
        [[0, -2], [5, -2], [5, 2], [0, 2]],
        [[5, -1], [6, -1], [6, 1], [5, 1]]
    ],
    684: [
        [[0, -2], [5, -2], [5, 2], [0, 2]],
        [[0, 1.5], [0, 2.5]],
        [[0, -1.5], [0, -2.5]]
    ],
    685: [
        [[0, -1.5], [0, -2.5]],
        [[0, 1.5], [0, 2.5]],
        [[0, -2], [1.27, -2], [2.54, -2], [3.81, -2], [5, -2], [5, -0.73], [5, 0.54], [5, 1.81], [5, 2], [3.73, 2], [2.46, 2], [1.19, 2], [0, 2]],
        [[5, 1], [4, 1], [3.8, 0.6], [3.4, 0.5], [3.05, 0.77], [3.05, 1.2], [3.4, 1.5], [3.8, 1.4], [4, 1]]
    ],
    686: [
        [[-0.5, -2], [-0.5, -0.5], [-0.5, 0], [0.5, 0], [0.5, -1.5], [0.5, -2], [-0.5, -2], [-0.3, -1.7], [0.3, -1.7], [0.3, -1.4], [-0.3, -1.4], [-0.5, -1], [0.5, -1]]
    ],
    687: [
        [[-1, 0], [0.27, 0], [1, 0], [0.16, -1.27], [-0.69, -2.54], [-1, -3], [0.27, -3], [1, -3], [0.16, -1.73], [-0.69, -0.46], [-1, 0]],
        [[2.6, -0.05], [3.4, -0.05], [4.07, -0.43], [4.45, -1.1], [4.45, -1.9], [4.08, -2.55], [3.4, -2.95], [2.6, -2.95], [1.97, -2.58], [1.55, -1.9], [1.55, -1.1], [1.95, -0.45], [2.6, -0.05]]
    ],
    688: [
        [[0, -2], [0, 2]],
        [[-1, 1.5], [-1, 2.5]],
        [[-1, 2], [1, 2], [1, -2], [-1, -2]],
        [[-1, -2.5], [-1, -1.5]]
    ],
    689: [
        [[-1, -2], [-1, -1]],
        [[-1, -1.5], [0, -1.5], [0, -2], [1.5, -2], [2, -2], [2, 2], [0.5, 2], [0, 2], [0, -1.5], [0.6, -2]],
        [[2, -1.5], [0, 0]],
        [[0, 1.5], [2, 0]],
        [[2, 1.5], [1.4, 2]],
        [[0, 1.5], [-1, 1.5]],
        [[-1, 1], [-1, 2]]
    ],
    690: [
        [[0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5]]
    ],
    691: [
        [[0, -0.5], [0, 0.5]],
        [[-0.5, 0], [0.5, 0]]
    ],
    692: [
        [[-2.5, 0], [2.5, 0], [2.5, -0.75], [2.5, -1], [-2.5, -1], [-2.5, -0.25], [-2.5, 0], [-2.3, -0.35], [2.3, -0.35], [2.3, -0.65], [-2.3, -0.65]]
    ],
    693: [
        [[-6.75, 0], [-1.75, 0], [-1.75, -0.75], [-1.75, -1], [-6.75, -1], [-6.75, -0.25], [-6.75, 0], [-6.55, -0.35], [-1.95, -0.35], [-1.95, -0.65], [-6.55, -0.65]]
    ],
    694: [
        [[1.75, 0], [6.75, 0], [6.75, -0.75], [6.75, -1], [1.75, -1], [1.75, -0.25], [1.75, 0], [1.95, -0.35], [6.55, -0.35], [6.55, -0.65], [1.95, -0.65]]
    ],
    695: [
        [[-6, 0], [-1, 0], [-1, -0.75], [-1, -1], [-6, -1], [-6, -0.25], [-6, 0], [-5.8, -0.35], [-1.2, -0.35], [-1.2, -0.65], [-5.8, -0.65]]
    ],
    696: [
        [[1, 0], [6, 0], [6, -0.75], [6, -1], [1, -1], [1, -0.25], [1, 0], [1.2, -0.35], [5.8, -0.35], [5.8, -0.65], [1.2, -0.65]]
    ],
    697: [
        [[0, -0.75], [0.75, -0.75], [0.75, 0.52], [0.75, 0.75], [-0.52, 0.75], [-0.75, 0.75], [-0.75, -0.52], [-0.75, -0.75], [0, -0.75], [-0.49, -0.58], [-0.71, -0.13], [-0.64, 0.38], [-0.25, 0.7], [0.25, 0.7], [0.63, 0.38], [0.75, -0.15], [0.48, -0.58], [0, -0.75]]
    ],
    698: [
        [[-1, 0], [0.5, 0], [1, 0]],
        [[0, 0], [0, -1.5], [0, -2.4], [0.1, -2.8], [0.5, -3], [0.9, -2.8], [1, -2.4]],
        [[1, -3], [-0.5, -3], [-1, -3]]
    ],
    699: [
        [[-1, 0], [1, 0]],
        [[0, 0], [0, -3.45]],
        [[-1, -2.5], [-0.8, -3.1], [-0.3, -3.45], [0.3, -3.45], [0.85, -3.1], [1, -2.5]]
    ],
    700: [
        [[0, -0.5], [-0.4, -0.3], [-0.5, 0.1], [-0.2, 0.45], [0.2, 0.45], [0.5, 0.1], [0.4, -0.3], [0, -0.5], [0, -1.25], [0, -1.5]],
        [[-0.4, -1.1], [0, -1.5], [0.4, -1.1]]
    ],
    701: [
    ],
    702: [
    ]
};

export default SYMBOL_DATA;